// Deployment and workspace management for the Sunstone platform.
//
// This package models the infrastructure hierarchy for customer BAIC
// deployments. A tenant (defined in tenants/v1) may have multiple
// deployments across different cloud providers and regions, each
// containing workspaces.
//
// Entity relationships:
//
//   Tenant (tenants/v1)
//     └── Deployment (cloud provider + region + deployment model)
//           ├── Workspace (development)
//           ├── Workspace (staging)
//           └── Workspace (production)
//
// Each deployment is managed by a Control Plane (shared multi-tenant or
// dedicated).
//
// Workspaces within a deployment carry two independent state dimensions:
//   - WorkspaceStatus:        infrastructure lifecycle and health (provisioning → healthy/degraded/unavailable/blocked → inactive)
//   - WorkspaceUpgradeStatus: BAIC platform upgrade state (none → scheduled → in progress → complete)
//
// These are orthogonal — a workspace remains HEALTHY and serving traffic
// while upgrades are scheduled or in progress (rolling updates).
//
// See also:
//   - tenants/v1/tenants.proto       — tenant and user management
//   - bootstrap/v1/bootstrap.proto   — cloud bootstrap callback
//
// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file deployments/v1/deployments.proto (package deployments.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_common } from "../../common/v1/common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Release, ReleaseSyncStatus } from "../../releases/v1/releases_pb";
import { file_releases_v1_releases } from "../../releases/v1/releases_pb";
import type { AccessRuleInput } from "../../tenants/v1/tenants_pb";
import { file_tenants_v1_tenants } from "../../tenants/v1/tenants_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file deployments/v1/deployments.proto.
 */
export const file_deployments_v1_deployments: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_common, file_google_protobuf_timestamp, file_releases_v1_releases, file_tenants_v1_tenants]);

/**
 * Deployment represents a customer's BAIC deployment in a specific cloud
 * provider and region. A tenant (see tenants/v1) may have multiple
 * deployments across different providers and regions.
 *
 * Each deployment is managed by a Control Plane (shared or dedicated) and
 * contains one or more Workspaces (development, staging, production),
 * each of which is a separate Kubernetes cluster in the customer's
 * infrastructure.
 *
 * The deployment tracks the infrastructure lifecycle from initial cloud
 * bootstrap through ongoing operations. For BYOC deployments, the customer
 * launches a provider-specific bootstrap template that provisions IAM
 * roles, security groups, and S3 buckets, then delivers credentials to
 * the Management Plane via a callback Lambda.
 *
 * @generated from message deployments.v1.Deployment
 */
export type Deployment = Message<"deployments.v1.Deployment"> & {
  /**
   * Unique deployment identifier.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Tenant that owns this deployment.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * Human-readable display name (e.g. "AWS US-East Production").
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * URL-friendly slug for this deployment. Used in URLs and API references.
   * Constraints: max 63 characters, lowercase alphanumeric + hyphens,
   * DNS-compliant (RFC 1123), unique within the owning tenant.
   *
   * @generated from field: string slug = 11;
   */
  slug: string;

  /**
   * Cloud provider or on-prem infrastructure type.
   *
   * @generated from field: deployments.v1.DeploymentType deployment_type = 4;
   */
  deploymentType: DeploymentType;

  /**
   * Customer's chosen deployment model, which determines where BAIC
   * components and AI/ML inferencing run.
   *
   * @generated from field: deployments.v1.DeploymentModel deployment_model = 5;
   */
  deploymentModel: DeploymentModel;

  /**
   * Cloud region where the Data Plane runs
   * (e.g. "us-east-1", "eu-west-1", "us-central1").
   * Empty for on-prem deployments.
   *
   * @generated from field: string region = 6;
   */
  region: string;

  /**
   * Current infrastructure lifecycle status. See DeploymentStatus for
   * the full state machine including bootstrap and provisioning states.
   *
   * @generated from field: deployments.v1.DeploymentStatus status = 8;
   */
  status: DeploymentStatus;

  /**
   * When the deployment record was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * When the deployment record was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string batman = 12;
   */
  batman: string;

  /**
   * Display name of the owning tenant. Populated in list responses for cross-tenant views.
   *
   * @generated from field: string tenant_name = 13;
   */
  tenantName: string;

  /**
   * DuploCloud portal URL for this deployment. Populated after successful provisioning.
   *
   * @generated from field: string duplo_portal_url = 14;
   */
  duploPortalUrl: string;

  /**
   * Resolved base domain for this deployment, e.g.
   * "acme.staging.baic.uniphorecloud.com" (or "acme.uniphorecloud.com" for SAAS).
   * This is the customer deployment's hosted zone, env-scoped by the management-plane
   * environment the deployment lives in — NOT any workspace's environment label, and
   * NOT the management plane's own domain. Clients should use this as the authoritative
   * base domain (e.g. to build a workspace's "forge-ui-<slug>.<deployment_domain>" URL)
   * rather than reconstructing it from parts. Populated by GetDeployment.
   *
   * @generated from field: string deployment_domain = 15;
   */
  deploymentDomain: string;
};

/**
 * Describes the message deployments.v1.Deployment.
 * Use `create(DeploymentSchema)` to create a new message.
 */
export const DeploymentSchema: GenMessage<Deployment> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 0);

/**
 * Workspace represents a single Kubernetes cluster environment within a
 * deployment. Customers typically have development, staging, and production
 * workspaces, each being a separate K8s cluster in their infrastructure.
 *
 * Workspaces carry two independent state dimensions:
 *   - status:         infrastructure lifecycle and health (WorkspaceStatus)
 *   - upgrade_status: BAIC platform upgrade state (WorkspaceUpgradeStatus)
 *
 * These are orthogonal — a workspace remains HEALTHY and serving traffic
 * while upgrades are scheduled or in progress (rolling updates).
 *
 * Platform upgrades flow sequentially through workspaces within a
 * deployment: development → staging → production, with customer-controlled
 * validation periods (typically 3-7 days) between each stage.
 *
 * @generated from message deployments.v1.Workspace
 */
export type Workspace = Message<"deployments.v1.Workspace"> & {
  /**
   * Unique workspace identifier.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Deployment this workspace belongs to.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;

  /**
   * Environment purpose (development, staging, production).
   * Determines the workspace's position in the upgrade sequence.
   *
   * @generated from field: deployments.v1.WorkspaceEnvironment environment = 3;
   */
  environment: WorkspaceEnvironment;

  /**
   * Human-readable display name.
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * URL-friendly slug for this workspace. Used in URLs and API references.
   * Constraints: max 63 characters, lowercase alphanumeric + hyphens,
   * DNS-compliant (RFC 1123), unique within the owning deployment.
   *
   * @generated from field: string slug = 12;
   */
  slug: string;

  /**
   * Infrastructure lifecycle status. Independent of upgrade state.
   *
   * @generated from field: deployments.v1.WorkspaceStatus status = 5;
   */
  status: WorkspaceStatus;

  /**
   * Currently running BAIC platform version (e.g. "2.5.0").
   * Updated after a successful upgrade or rollback.
   *
   * @generated from field: string current_version = 6;
   */
  currentVersion: string;

  /**
   * Current BAIC platform upgrade state. Orthogonal to status — the
   * workspace remains HEALTHY during upgrades (rolling updates).
   * See WorkspaceUpgradeStatus for the full state machine.
   *
   * @generated from field: deployments.v1.WorkspaceUpgradeStatus upgrade_status = 7;
   */
  upgradeStatus: WorkspaceUpgradeStatus;

  /**
   * Target version for a scheduled or in-progress upgrade (e.g. "2.6.0").
   * Matches current_version when no upgrade is pending.
   *
   * @generated from field: string target_version = 8;
   */
  targetVersion: string;

  /**
   * When the next upgrade is scheduled to execute. Only set when
   * upgrade_status is SCHEDULED. Customers can reschedule this within
   * their assigned release wave window via the Management Plane UI.
   *
   * @generated from field: google.protobuf.Timestamp upgrade_scheduled_at = 9;
   */
  upgradeScheduledAt?: Timestamp;

  /**
   * When the workspace record was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * When the workspace record was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * Kubernetes cluster name used for ArgoCD routing.
   * Example: "uniphore.teleport.sh-uniphore-dev-us-eks-platform"
   * Empty string means not yet configured.
   *
   * @generated from field: string cluster_name = 13;
   */
  clusterName: string;

  /**
   * Tenant this workspace's deployment belongs to.
   * Populated on global list responses (when listing without a deployment_id filter).
   *
   * @generated from field: string tenant_id = 14;
   */
  tenantId: string;

  /**
   * Display name of the owning deployment.
   * Populated on global list responses (when listing without a deployment_id filter).
   *
   * @generated from field: string deployment_display_name = 15;
   */
  deploymentDisplayName: string;

  /**
   * Display name of the owning tenant. Populated in list responses for cross-tenant views.
   *
   * @generated from field: string tenant_name = 16;
   */
  tenantName: string;

  /**
   * Typed ID of the release currently running in this workspace (rel_[20]).
   * Populated when the workspace was created or upgraded via release_id.
   * Empty for legacy workspaces created with a version string only.
   *
   * @generated from field: string current_release_id = 17;
   */
  currentReleaseId: string;

  /**
   * Typed ID of the release this workspace is scheduled or in-progress to upgrade to.
   * Empty when no upgrade is pending.
   *
   * @generated from field: string target_release_id = 18;
   */
  targetReleaseId: string;

  /**
   * True when the workspace's current release is marked deprecated.
   * False when current_release_id is unset (legacy workspace).
   *
   * @generated from field: bool is_deprecated = 19;
   */
  isDeprecated: boolean;

  /**
   * True when the workspace is running the latest non-deprecated release for its group.
   * False when current_release_id is unset (legacy workspace) or a newer release exists.
   *
   * @generated from field: bool is_latest = 20;
   */
  isLatest: boolean;

  /**
   * X-Forge UI URL for this workspace. Populated after successful provisioning.
   *
   * @generated from field: string forge_ui_url = 21;
   */
  forgeUiUrl: string;

  /**
   * When this workspace last completed a release promote. Unset if the
   * workspace has never been promoted.
   *
   * @generated from field: google.protobuf.Timestamp last_promoted_at = 22;
   */
  lastPromotedAt?: Timestamp;

  /**
   * The full manifest of what's actually deployed in this workspace right
   * now (release_metadata). Populated only on GetWorkspace, never on
   * ListWorkspaces. Unset for workspaces that have never completed a
   * PromoteRelease since release tracking shipped.
   *
   * @generated from field: deployments.v1.DeployedReleaseManifest deployed_release_manifest = 23;
   */
  deployedReleaseManifest?: DeployedReleaseManifest;

  /**
   * True when the workspace's current release has been disabled by an
   * operator_admin. False when current_release_id is unset (legacy
   * workspace) or the current release is enabled.
   *
   * @generated from field: bool is_disabled = 25;
   */
  isDisabled: boolean;

  /**
   * The Duplo infra ("plan") this workspace is assigned to. Set at creation from
   * the operator's chosen infra, filled in when provisioning auto-resolves
   * placement, and reconciled to observed reality by Duplo tenant sync. Empty
   * until the workspace's infra has been resolved.
   *
   * @generated from field: string infra = 26;
   */
  infra: string;
};

/**
 * Describes the message deployments.v1.Workspace.
 * Use `create(WorkspaceSchema)` to create a new message.
 */
export const WorkspaceSchema: GenMessage<Workspace> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 1);

/**
 * ControlPlane represents a Kubernetes-based orchestration engine that
 * manages customer deployments.
 *   - Pulling configuration from Git via ArgoCD (aggressive sync)
 *   - Provisioning customer cloud resources via Duplo
 *   - Pushing deployments into customer Data Planes via IAM role assumption
 *   - Monitoring infrastructure drift and auto-remediating
 *
 * By default, all customers share a single Control Plane cluster with
 * namespace isolation. Dedicated Control Planes are available for
 * high-security customers requiring complete infrastructure isolation.
 *
 * @generated from message deployments.v1.ControlPlane
 */
export type ControlPlane = Message<"deployments.v1.ControlPlane"> & {
  /**
   * Unique control plane identifier.
   * Format: ctrlplane_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Human-readable display name.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Whether this is a shared multi-tenant or dedicated single-tenant
   * Control Plane. See ControlPlaneType for isolation characteristics.
   *
   * @generated from field: deployments.v1.ControlPlaneType control_plane_type = 3;
   */
  controlPlaneType: ControlPlaneType;

  /**
   * Cloud region where this Control Plane runs.
   *
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * When the control plane record was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message deployments.v1.ControlPlane.
 * Use `create(ControlPlaneSchema)` to create a new message.
 */
export const ControlPlaneSchema: GenMessage<ControlPlane> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 2);

/**
 * CreateDeploymentRequest creates a new BAIC deployment for a tenant.
 * The deployment starts in CREATED status with a bootstrap template
 * available for the customer (BYOC models) or proceeds directly to
 * PROVISIONING (SaaS model).
 *
 * @generated from message deployments.v1.CreateDeploymentRequest
 */
export type CreateDeploymentRequest = Message<"deployments.v1.CreateDeploymentRequest"> & {
  /**
   * Tenant that owns this deployment.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Human-readable display name.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * URL-friendly slug. Must be unique within the tenant, max 63 characters,
   * lowercase alphanumeric + hyphens, DNS-compliant.
   *
   * @generated from field: string slug = 7;
   */
  slug: string;

  /**
   * Cloud provider or on-prem infrastructure type.
   *
   * @generated from field: deployments.v1.DeploymentType deployment_type = 3;
   */
  deploymentType: DeploymentType;

  /**
   * Deployment model (hybrid, full customer VPC, on-prem, SaaS).
   *
   * @generated from field: deployments.v1.DeploymentModel deployment_model = 4;
   */
  deploymentModel: DeploymentModel;

  /**
   * Cloud region (e.g. "us-east-1"). Empty for on-prem deployments.
   *
   * @generated from field: string region = 5;
   */
  region: string;
};

/**
 * Describes the message deployments.v1.CreateDeploymentRequest.
 * Use `create(CreateDeploymentRequestSchema)` to create a new message.
 */
export const CreateDeploymentRequestSchema: GenMessage<CreateDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 3);

/**
 * @generated from message deployments.v1.CreateDeploymentResponse
 */
export type CreateDeploymentResponse = Message<"deployments.v1.CreateDeploymentResponse"> & {
  /**
   * The newly created deployment in AWAITING_BOOTSTRAP status (BYOC) or
   * PROVISIONING status (SaaS), including server-generated fields.
   *
   * @generated from field: deployments.v1.Deployment deployment = 1;
   */
  deployment?: Deployment;

  /**
   * Presigned URL for downloading the provider-specific bootstrap template.
   * For AWS this is a CloudFormation YAML template.
   * Only set for BYOC deployment models that require bootstrap.
   * Empty for SaaS deployments.
   *
   * @generated from field: string bootstrap_url = 2;
   */
  bootstrapUrl: string;

  /**
   * Provider console URL with the bootstrap template pre-loaded.
   * For AWS: CloudFormation console URL with templateURL parameter.
   * For GCP: (future) Deployment Manager URL.
   * For Azure: (future) ARM template deployment URL.
   * Empty for SaaS deployments.
   *
   * @generated from field: string bootstrap_console_url = 3;
   */
  bootstrapConsoleUrl: string;
};

/**
 * Describes the message deployments.v1.CreateDeploymentResponse.
 * Use `create(CreateDeploymentResponseSchema)` to create a new message.
 */
export const CreateDeploymentResponseSchema: GenMessage<CreateDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 4);

/**
 * @generated from message deployments.v1.GetDeploymentRequest
 */
export type GetDeploymentRequest = Message<"deployments.v1.GetDeploymentRequest"> & {
  /**
   * The deployment ID to retrieve.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message deployments.v1.GetDeploymentRequest.
 * Use `create(GetDeploymentRequestSchema)` to create a new message.
 */
export const GetDeploymentRequestSchema: GenMessage<GetDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 5);

/**
 * @generated from message deployments.v1.GetDeploymentResponse
 */
export type GetDeploymentResponse = Message<"deployments.v1.GetDeploymentResponse"> & {
  /**
   * @generated from field: deployments.v1.Deployment deployment = 1;
   */
  deployment?: Deployment;

  /**
   * Presigned URL for downloading the provider-specific bootstrap template.
   * For AWS this is a CloudFormation YAML template.
   * Only set for BYOC deployment models that require bootstrap.
   * Empty for SaaS deployments.
   *
   * @generated from field: string bootstrap_url = 2;
   */
  bootstrapUrl: string;

  /**
   * Provider console URL with the bootstrap template pre-loaded.
   * For AWS: CloudFormation console URL with templateURL parameter.
   * For GCP: (future) Deployment Manager URL.
   * For Azure: (future) ARM template deployment URL.
   * Empty for SaaS deployments.
   *
   * @generated from field: string bootstrap_console_url = 3;
   */
  bootstrapConsoleUrl: string;
};

/**
 * Describes the message deployments.v1.GetDeploymentResponse.
 * Use `create(GetDeploymentResponseSchema)` to create a new message.
 */
export const GetDeploymentResponseSchema: GenMessage<GetDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 6);

/**
 * ListDeploymentsRequest returns deployments, optionally filtered by tenant.
 * Set exactly one of tenant_id or parent_tenant_id for scoped access.
 *
 * @generated from message deployments.v1.ListDeploymentsRequest
 */
export type ListDeploymentsRequest = Message<"deployments.v1.ListDeploymentsRequest"> & {
  /**
   * Filter by direct tenant ID. Returns only that tenant's own deployments.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Pagination token from a previous ListDeploymentsResponse.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Filter by parent tenant ID. Returns deployments owned by all child
   * tenants of the given partner. Used for partner-level infrastructure
   * overviews. Mutually exclusive with tenant_id.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string parent_tenant_id = 4;
   */
  parentTenantId: string;

  /**
   * Search across display_name, slug, and region. Empty means no search filter.
   *
   * @generated from field: string search = 5;
   */
  search: string;

  /**
   * Filter by cloud/deployment type. UNSPECIFIED means no type filter.
   *
   * @generated from field: deployments.v1.DeploymentType deployment_type_filter = 6;
   */
  deploymentTypeFilter: DeploymentType;

  /**
   * Filter by status. UNSPECIFIED means no status filter.
   *
   * @generated from field: deployments.v1.DeploymentStatus status_filter = 7;
   */
  statusFilter: DeploymentStatus;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 8;
   */
  page: number;
};

/**
 * Describes the message deployments.v1.ListDeploymentsRequest.
 * Use `create(ListDeploymentsRequestSchema)` to create a new message.
 */
export const ListDeploymentsRequestSchema: GenMessage<ListDeploymentsRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 7);

/**
 * @generated from message deployments.v1.ListDeploymentsResponse
 */
export type ListDeploymentsResponse = Message<"deployments.v1.ListDeploymentsResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.Deployment deployments = 1;
   */
  deployments: Deployment[];

  /**
   * Token for the next page of results. Empty if no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of deployments matching the current search/filter.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message deployments.v1.ListDeploymentsResponse.
 * Use `create(ListDeploymentsResponseSchema)` to create a new message.
 */
export const ListDeploymentsResponseSchema: GenMessage<ListDeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 8);

/**
 * ListAccessibleDeploymentsRequest lists deployments visible under a
 * candidate (not necessarily persisted) access-rule scope — used by the
 * access wizard's resource pickers and the restriction builder's live
 * "currently matches" preview, in place of the retired
 * PreviewAccessRuleMatch. Unlike ListDeployments, this never consults the
 * caller's own access_rules — role_rules/user_rules entirely decide
 * visibility.
 *
 * role_rules and user_rules are accessrule.gateBoth's two independent
 * envelopes: role_rules is the outer envelope (its own deny, or failing to
 * match an allow-rule whitelist, wins outright); user_rules only ever
 * narrows further within whatever role_rules already allows. Rows of the
 * same envelope with the same resource_kind OR together (an allow-rule
 * whitelist union, mirroring accessrule.gate); the two envelopes AND
 * together. Both empty means no candidate rules at all — every deployment
 * in scope is returned, matching gate()'s open-by-default with no rows.
 *
 * These names are gateBoth's outer/inner slots, not a literal role-vs-user
 * identity check: when there is no "user" layer at all (e.g. a role
 * wizard scoping its own picker), put that role's own in-progress rule in
 * role_rules and leave user_rules empty.
 *
 * @generated from message deployments.v1.ListAccessibleDeploymentsRequest
 */
export type ListAccessibleDeploymentsRequest = Message<"deployments.v1.ListAccessibleDeploymentsRequest"> & {
  /**
   * Filter by direct tenant ID. Mutually exclusive with parent_tenant_id.
   * Empty means the caller's own accessible-tenant scope.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Filter by parent tenant ID — deployments owned by all child tenants of
   * the given partner. Mutually exclusive with tenant_id.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string parent_tenant_id = 2;
   */
  parentTenantId: string;

  /**
   * Search across display_name, slug, and region. Empty means no search filter.
   *
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * @generated from field: repeated tenants.v1.AccessRuleInput role_rules = 6;
   */
  roleRules: AccessRuleInput[];

  /**
   * @generated from field: repeated tenants.v1.AccessRuleInput user_rules = 7;
   */
  userRules: AccessRuleInput[];
};

/**
 * Describes the message deployments.v1.ListAccessibleDeploymentsRequest.
 * Use `create(ListAccessibleDeploymentsRequestSchema)` to create a new message.
 */
export const ListAccessibleDeploymentsRequestSchema: GenMessage<ListAccessibleDeploymentsRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 9);

/**
 * @generated from message deployments.v1.ListAccessibleDeploymentsResponse
 */
export type ListAccessibleDeploymentsResponse = Message<"deployments.v1.ListAccessibleDeploymentsResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.Deployment deployments = 1;
   */
  deployments: Deployment[];

  /**
   * Always empty — page-number pagination is used instead, matching
   * ListDeploymentsResponse's own handler, which never populates this
   * either. Kept only for shape parity.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of deployments matching the current search/filter/rules.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message deployments.v1.ListAccessibleDeploymentsResponse.
 * Use `create(ListAccessibleDeploymentsResponseSchema)` to create a new message.
 */
export const ListAccessibleDeploymentsResponseSchema: GenMessage<ListAccessibleDeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 10);

/**
 * GetBootstrapTemplateRequest retrieves the rendered bootstrap template
 * (e.g. CloudFormation YAML) for a deployment from cloud storage.
 *
 * @generated from message deployments.v1.GetBootstrapTemplateRequest
 */
export type GetBootstrapTemplateRequest = Message<"deployments.v1.GetBootstrapTemplateRequest"> & {
  /**
   * The deployment whose bootstrap template to retrieve.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message deployments.v1.GetBootstrapTemplateRequest.
 * Use `create(GetBootstrapTemplateRequestSchema)` to create a new message.
 */
export const GetBootstrapTemplateRequestSchema: GenMessage<GetBootstrapTemplateRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 11);

/**
 * @generated from message deployments.v1.GetBootstrapTemplateResponse
 */
export type GetBootstrapTemplateResponse = Message<"deployments.v1.GetBootstrapTemplateResponse"> & {
  /**
   * The rendered bootstrap template content (e.g. CloudFormation YAML).
   *
   * @generated from field: string template = 1;
   */
  template: string;
};

/**
 * Describes the message deployments.v1.GetBootstrapTemplateResponse.
 * Use `create(GetBootstrapTemplateResponseSchema)` to create a new message.
 */
export const GetBootstrapTemplateResponseSchema: GenMessage<GetBootstrapTemplateResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 12);

/**
 * @generated from message deployments.v1.DeleteDeploymentRequest
 */
export type DeleteDeploymentRequest = Message<"deployments.v1.DeleteDeploymentRequest"> & {
  /**
   * The deployment to deprovision.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Controls how the deployment is deleted.
   * DELETE_MODE_FULL (default) runs the Temporal deprovision workflow.
   * DELETE_MODE_FORCE_TOMBSTONE skips infrastructure teardown.
   *
   * @generated from field: deployments.v1.DeleteMode mode = 2;
   */
  mode: DeleteMode;
};

/**
 * Describes the message deployments.v1.DeleteDeploymentRequest.
 * Use `create(DeleteDeploymentRequestSchema)` to create a new message.
 */
export const DeleteDeploymentRequestSchema: GenMessage<DeleteDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 13);

/**
 * @generated from message deployments.v1.DeleteDeploymentResponse
 */
export type DeleteDeploymentResponse = Message<"deployments.v1.DeleteDeploymentResponse"> & {
};

/**
 * Describes the message deployments.v1.DeleteDeploymentResponse.
 * Use `create(DeleteDeploymentResponseSchema)` to create a new message.
 */
export const DeleteDeploymentResponseSchema: GenMessage<DeleteDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 14);

/**
 * BlockingResource represents a child resource that must be deleted before
 * its parent can be deleted.
 *
 * @generated from message deployments.v1.BlockingResource
 */
export type BlockingResource = Message<"deployments.v1.BlockingResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * resource_type is one of: "workspace", "deployment", "tenant".
   *
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;
};

/**
 * Describes the message deployments.v1.BlockingResource.
 * Use `create(BlockingResourceSchema)` to create a new message.
 */
export const BlockingResourceSchema: GenMessage<BlockingResource> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 15);

/**
 * @generated from message deployments.v1.CheckDeploymentDeleteBlockersRequest
 */
export type CheckDeploymentDeleteBlockersRequest = Message<"deployments.v1.CheckDeploymentDeleteBlockersRequest"> & {
  /**
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message deployments.v1.CheckDeploymentDeleteBlockersRequest.
 * Use `create(CheckDeploymentDeleteBlockersRequestSchema)` to create a new message.
 */
export const CheckDeploymentDeleteBlockersRequestSchema: GenMessage<CheckDeploymentDeleteBlockersRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 16);

/**
 * @generated from message deployments.v1.CheckDeploymentDeleteBlockersResponse
 */
export type CheckDeploymentDeleteBlockersResponse = Message<"deployments.v1.CheckDeploymentDeleteBlockersResponse"> & {
  /**
   * Active workspaces that must be deleted before this deployment can be deleted.
   * An empty list means deletion is allowed.
   *
   * @generated from field: repeated deployments.v1.BlockingResource blocking_resources = 1;
   */
  blockingResources: BlockingResource[];
};

/**
 * Describes the message deployments.v1.CheckDeploymentDeleteBlockersResponse.
 * Use `create(CheckDeploymentDeleteBlockersResponseSchema)` to create a new message.
 */
export const CheckDeploymentDeleteBlockersResponseSchema: GenMessage<CheckDeploymentDeleteBlockersResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 17);

/**
 * ListControlPlanesRequest returns control planes, optionally filtered by region.
 *
 * @generated from message deployments.v1.ListControlPlanesRequest
 */
export type ListControlPlanesRequest = Message<"deployments.v1.ListControlPlanesRequest"> & {
  /**
   * Filter by cloud region (e.g. "us-east-1"). If empty, returns control planes
   * across all regions.
   *
   * @generated from field: string region = 1;
   */
  region: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Pagination token from a previous ListControlPlanesResponse.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message deployments.v1.ListControlPlanesRequest.
 * Use `create(ListControlPlanesRequestSchema)` to create a new message.
 */
export const ListControlPlanesRequestSchema: GenMessage<ListControlPlanesRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 18);

/**
 * @generated from message deployments.v1.ListControlPlanesResponse
 */
export type ListControlPlanesResponse = Message<"deployments.v1.ListControlPlanesResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.ControlPlane control_planes = 1;
   */
  controlPlanes: ControlPlane[];

  /**
   * Token for the next page of results. Empty if no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message deployments.v1.ListControlPlanesResponse.
 * Use `create(ListControlPlanesResponseSchema)` to create a new message.
 */
export const ListControlPlanesResponseSchema: GenMessage<ListControlPlanesResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 19);

/**
 * @generated from message deployments.v1.ListDeploymentInfrasRequest
 */
export type ListDeploymentInfrasRequest = Message<"deployments.v1.ListDeploymentInfrasRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message deployments.v1.ListDeploymentInfrasRequest.
 * Use `create(ListDeploymentInfrasRequestSchema)` to create a new message.
 */
export const ListDeploymentInfrasRequestSchema: GenMessage<ListDeploymentInfrasRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 20);

/**
 * DeploymentInfra is one DuploCloud infrastructure ("plan") in a deployment's
 * portal. Name is the identifier used as a workspace's infra for placement.
 *
 * @generated from message deployments.v1.DeploymentInfra
 */
export type DeploymentInfra = Message<"deployments.v1.DeploymentInfra"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message deployments.v1.DeploymentInfra.
 * Use `create(DeploymentInfraSchema)` to create a new message.
 */
export const DeploymentInfraSchema: GenMessage<DeploymentInfra> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 21);

/**
 * @generated from message deployments.v1.ListDeploymentInfrasResponse
 */
export type ListDeploymentInfrasResponse = Message<"deployments.v1.ListDeploymentInfrasResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.DeploymentInfra infras = 1;
   */
  infras: DeploymentInfra[];
};

/**
 * Describes the message deployments.v1.ListDeploymentInfrasResponse.
 * Use `create(ListDeploymentInfrasResponseSchema)` to create a new message.
 */
export const ListDeploymentInfrasResponseSchema: GenMessage<ListDeploymentInfrasResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 22);

/**
 * @generated from message deployments.v1.StreamDeploymentEventsRequest
 */
export type StreamDeploymentEventsRequest = Message<"deployments.v1.StreamDeploymentEventsRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message deployments.v1.StreamDeploymentEventsRequest.
 * Use `create(StreamDeploymentEventsRequestSchema)` to create a new message.
 */
export const StreamDeploymentEventsRequestSchema: GenMessage<StreamDeploymentEventsRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 23);

/**
 * @generated from message deployments.v1.StreamDeploymentEventsResponse
 */
export type StreamDeploymentEventsResponse = Message<"deployments.v1.StreamDeploymentEventsResponse"> & {
  /**
   * Raw JSON payload from pg_notify — decoded by the client.
   * Shapes: {"event_type":"status_changed","deployment_id":"...","status":"...","previous_status":"...","timestamp_ms":...}
   *         {"event_type":"audit_added","deployment_id":"...","audit_id":"...","timestamp_ms":...}
   *         {"event_type":"deployment.workflow_run_changed","deployment_id":"...","run_id":"...","status":"...","timestamp_ms":...}
   *
   * @generated from field: string payload = 1;
   */
  payload: string;
};

/**
 * Describes the message deployments.v1.StreamDeploymentEventsResponse.
 * Use `create(StreamDeploymentEventsResponseSchema)` to create a new message.
 */
export const StreamDeploymentEventsResponseSchema: GenMessage<StreamDeploymentEventsResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 24);

/**
 * @generated from message deployments.v1.TriggerTenantMigrationRequest
 */
export type TriggerTenantMigrationRequest = Message<"deployments.v1.TriggerTenantMigrationRequest"> & {
  /**
   * deployment ID (deploy_*)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message deployments.v1.TriggerTenantMigrationRequest.
 * Use `create(TriggerTenantMigrationRequestSchema)` to create a new message.
 */
export const TriggerTenantMigrationRequestSchema: GenMessage<TriggerTenantMigrationRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 25);

/**
 * @generated from message deployments.v1.TriggerTenantMigrationResponse
 */
export type TriggerTenantMigrationResponse = Message<"deployments.v1.TriggerTenantMigrationResponse"> & {
  /**
   * @generated from field: deployments.v1.Deployment deployment = 1;
   */
  deployment?: Deployment;
};

/**
 * Describes the message deployments.v1.TriggerTenantMigrationResponse.
 * Use `create(TriggerTenantMigrationResponseSchema)` to create a new message.
 */
export const TriggerTenantMigrationResponseSchema: GenMessage<TriggerTenantMigrationResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 26);

/**
 * @generated from message deployments.v1.GetLastDeploymentWorkflowRunRequest
 */
export type GetLastDeploymentWorkflowRunRequest = Message<"deployments.v1.GetLastDeploymentWorkflowRunRequest"> & {
  /**
   * The deployment whose last deployment-scoped workflow run to look up.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message deployments.v1.GetLastDeploymentWorkflowRunRequest.
 * Use `create(GetLastDeploymentWorkflowRunRequestSchema)` to create a new message.
 */
export const GetLastDeploymentWorkflowRunRequestSchema: GenMessage<GetLastDeploymentWorkflowRunRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 27);

/**
 * GetLastDeploymentWorkflowRunResponse mirrors GetLastWorkspaceWorkflowRunResponse
 * field-for-field (kept separate rather than shared - buf's RPC naming
 * convention requires a distinct response message per RPC) - see that
 * message's doc comment for field semantics.
 *
 * @generated from message deployments.v1.GetLastDeploymentWorkflowRunResponse
 */
export type GetLastDeploymentWorkflowRunResponse = Message<"deployments.v1.GetLastDeploymentWorkflowRunResponse"> & {
  /**
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * @generated from field: int64 since_ms = 3;
   */
  sinceMs: bigint;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string workflow = 5;
   */
  workflow: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string conclusion = 7;
   */
  conclusion: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 9;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: string release_id = 10;
   */
  releaseId: string;

  /**
   * @generated from field: string run_url = 11;
   */
  runUrl: string;
};

/**
 * Describes the message deployments.v1.GetLastDeploymentWorkflowRunResponse.
 * Use `create(GetLastDeploymentWorkflowRunResponseSchema)` to create a new message.
 */
export const GetLastDeploymentWorkflowRunResponseSchema: GenMessage<GetLastDeploymentWorkflowRunResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 28);

/**
 * CreateWorkspaceRequest provisions a new workspace (Kubernetes cluster)
 * within an existing deployment. The deployment must be in ACTIVE status.
 *
 * @generated from message deployments.v1.CreateWorkspaceRequest
 */
export type CreateWorkspaceRequest = Message<"deployments.v1.CreateWorkspaceRequest"> & {
  /**
   * Deployment this workspace belongs to. Must be in ACTIVE status.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Environment purpose. Determines the workspace's position in the
   * upgrade sequence (development → staging → production).
   *
   * @generated from field: deployments.v1.WorkspaceEnvironment environment = 2;
   */
  environment: WorkspaceEnvironment;

  /**
   * Human-readable display name.
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * URL-friendly slug. Must be unique within the deployment, max 12 characters,
   * lowercase alphanumeric + hyphens, DNS-compliant.
   * Used directly as infra_name in new_infra.yml.
   *
   * @generated from field: string slug = 4;
   */
  slug: string;

  /**
   * Initial release version (e.g. "1.09") to deploy into this workspace.
   * Ignored when release_id is provided — the version is derived from the release record.
   * Must match a known release (see ReleasesService.ListReleases).
   *
   * @generated from field: string current_version = 5;
   */
  currentVersion: string;

  /**
   * Optional: typed release ID (rel_[20]) to associate as the initial release.
   * When set, current_version is derived from the release record and this field
   * takes precedence. Enables lifecycle queries (ListAvailableReleases, version status).
   *
   * @generated from field: string release_id = 6;
   */
  releaseId: string;

  /**
   * DEPRECATED: ignored. Sunstone allocates the workspace VPC CIDR from a
   * fixed pool (see internal/management/services/v1/workspace/cidr) so that
   * peering routes between the master VPC and per-workspace tenant VPCs do
   * not collide. Client-supplied values are silently dropped.
   *
   * @generated from field: string infra_cidr = 7 [deprecated = true];
   * @deprecated
   */
  infraCidr: string;

  /**
   * Subnet mask prefix length (e.g. 20).
   * Defaults to 20 if not provided.
   *
   * @generated from field: int32 subnet_mask = 8;
   */
  subnetMask: number;

  /**
   * Optional domain name override for the workspace
   * (e.g. "myworkspace.baic.uniphorecloud.com").
   *
   * @generated from field: string domain = 9;
   */
  domain: string;

  /**
   * Whether to enable the Wiz security sensor in this workspace.
   *
   * @generated from field: bool enable_wiz = 10;
   */
  enableWiz: boolean;

  /**
   * Whether the caller has acknowledged any preflight checks that could not be
   * verified (PreflightOutcome NEEDS_DECISION) and wants the install to proceed
   * anyway. Set by the preflight dialog's "Continue anyway" choice. When the
   * preflight gate runs inside the install workflow (see RunWorkspacePreflight),
   * a NEEDS_DECISION outcome aborts the install unless this is true. Has no
   * effect on a BLOCKED outcome, which always aborts.
   *
   * @generated from field: bool acknowledge_unknowns = 11;
   */
  acknowledgeUnknowns: boolean;

  /**
   * Optional: target Duplo infra ("plan") for workspace placement.
   * When set, the workspace's tenant is placed into that infra; it must be an
   * existing infra once the deployment has a shared infra (centxforge present).
   * When unset on the first workspace, the infra name is derived from the slug.
   * Persisted as the workspace's `infra` field.
   *
   * @generated from field: string infra = 12;
   */
  infra: string;

  /**
   * SUN-391: when true, `infra` names a NEW infra to create in this (existing)
   * deployment as part of provisioning this workspace, rather than an existing
   * one. Explicit by design — an unrecognised `infra` with create_infra=false
   * still fails closed. Gated by the FEATURE_CREATE_INFRA_IN_EXISTING_DEPLOYMENT
   * flag; rejected at the API when the flag is off or the named infra already
   * exists. Not persisted — drives request-time validation only.
   *
   * @generated from field: bool create_infra = 13;
   */
  createInfra: boolean;
};

/**
 * Describes the message deployments.v1.CreateWorkspaceRequest.
 * Use `create(CreateWorkspaceRequestSchema)` to create a new message.
 */
export const CreateWorkspaceRequestSchema: GenMessage<CreateWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 29);

/**
 * @generated from message deployments.v1.CreateWorkspaceResponse
 */
export type CreateWorkspaceResponse = Message<"deployments.v1.CreateWorkspaceResponse"> & {
  /**
   * The newly created workspace in PROVISIONING status, including
   * server-generated fields (id, status, timestamps).
   *
   * @generated from field: deployments.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;
};

/**
 * Describes the message deployments.v1.CreateWorkspaceResponse.
 * Use `create(CreateWorkspaceResponseSchema)` to create a new message.
 */
export const CreateWorkspaceResponseSchema: GenMessage<CreateWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 30);

/**
 * @generated from message deployments.v1.GetWorkspaceRequest
 */
export type GetWorkspaceRequest = Message<"deployments.v1.GetWorkspaceRequest"> & {
  /**
   * The workspace ID to retrieve.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message deployments.v1.GetWorkspaceRequest.
 * Use `create(GetWorkspaceRequestSchema)` to create a new message.
 */
export const GetWorkspaceRequestSchema: GenMessage<GetWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 31);

/**
 * @generated from message deployments.v1.GetWorkspaceResponse
 */
export type GetWorkspaceResponse = Message<"deployments.v1.GetWorkspaceResponse"> & {
  /**
   * @generated from field: deployments.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;
};

/**
 * Describes the message deployments.v1.GetWorkspaceResponse.
 * Use `create(GetWorkspaceResponseSchema)` to create a new message.
 */
export const GetWorkspaceResponseSchema: GenMessage<GetWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 32);

/**
 * ListWorkspacesRequest returns workspaces, optionally filtered by deployment.
 *
 * @generated from message deployments.v1.ListWorkspacesRequest
 */
export type ListWorkspacesRequest = Message<"deployments.v1.ListWorkspacesRequest"> & {
  /**
   * Filter by deployment ID. If empty, returns all workspaces accessible to
   * the caller. If set, filters to only that deployment's workspaces.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Pagination token from a previous ListWorkspacesResponse.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Search across display_name and slug. Empty means no search filter.
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * Optional environment filter. UNSPECIFIED means no filter.
   *
   * @generated from field: deployments.v1.WorkspaceEnvironment environment_filter = 6;
   */
  environmentFilter: WorkspaceEnvironment;

  /**
   * Optional status filter. UNSPECIFIED means no filter.
   *
   * @generated from field: deployments.v1.WorkspaceStatus status_filter = 7;
   */
  statusFilter: WorkspaceStatus;

  /**
   * Optional release ID filter. Matches workspaces whose current_release_id
   * OR target_release_id equals this release. Empty means no filter.
   *
   * @generated from field: string release_id_filter = 8;
   */
  releaseIdFilter: string;

  /**
   * Optional tenant filter — only applies when deployment_id is empty.
   * Narrows the global list to exactly this tenant, on top of (never
   * instead of) the caller's own accessible-tenant scope. Empty means no
   * additional narrowing.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 9;
   */
  tenantId: string;
};

/**
 * Describes the message deployments.v1.ListWorkspacesRequest.
 * Use `create(ListWorkspacesRequestSchema)` to create a new message.
 */
export const ListWorkspacesRequestSchema: GenMessage<ListWorkspacesRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 33);

/**
 * @generated from message deployments.v1.ListWorkspacesResponse
 */
export type ListWorkspacesResponse = Message<"deployments.v1.ListWorkspacesResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.Workspace workspaces = 1;
   */
  workspaces: Workspace[];

  /**
   * Token for the next page of results. Empty if no more results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of workspaces matching the current search/filter.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message deployments.v1.ListWorkspacesResponse.
 * Use `create(ListWorkspacesResponseSchema)` to create a new message.
 */
export const ListWorkspacesResponseSchema: GenMessage<ListWorkspacesResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 34);

/**
 * ListAccessibleWorkspacesRequest is ListAccessibleDeploymentsRequest's
 * workspace counterpart — see that message's comment for the
 * role_rules/user_rules envelope semantics. role_rules/user_rules may
 * contain BOTH deployment-kind and workspace-kind AccessRuleInput rows in
 * the same envelope — each row's own resource_kind tells them apart,
 * exactly as accessrule.filterByKind already does for a role's/user's full
 * rule set. The two kinds are gated independently and ANDed
 * (accessrule.decide's parent cascade: a workspace is only reachable if
 * its own gate passes AND its parent deployment's gate passes), so a
 * deployment-kind row here is how a caller gates a workspace by its parent
 * deployment without a separate call.
 *
 * @generated from message deployments.v1.ListAccessibleWorkspacesRequest
 */
export type ListAccessibleWorkspacesRequest = Message<"deployments.v1.ListAccessibleWorkspacesRequest"> & {
  /**
   * Filter by direct tenant ID. Empty means the caller's own
   * accessible-tenant scope, matching ListWorkspacesRequest.tenant_id.
   * Mutually exclusive with parent_tenant_id.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Search across display_name and slug. Empty means no search filter.
   *
   * @generated from field: string search = 2;
   */
  search: string;

  /**
   * Maximum number of results to return. Server may return fewer.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * 1-indexed page number. 0 or 1 means the first page.
   *
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * @generated from field: repeated tenants.v1.AccessRuleInput role_rules = 5;
   */
  roleRules: AccessRuleInput[];

  /**
   * @generated from field: repeated tenants.v1.AccessRuleInput user_rules = 6;
   */
  userRules: AccessRuleInput[];

  /**
   * Filter by parent tenant ID — workspaces owned by all child tenants of
   * the given partner (a partner tenant owns no deployments/workspaces
   * directly, so scoping a role/user to a partner needs this, not
   * tenant_id). Mutually exclusive with tenant_id.
   * Format: tenant_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string parent_tenant_id = 7;
   */
  parentTenantId: string;
};

/**
 * Describes the message deployments.v1.ListAccessibleWorkspacesRequest.
 * Use `create(ListAccessibleWorkspacesRequestSchema)` to create a new message.
 */
export const ListAccessibleWorkspacesRequestSchema: GenMessage<ListAccessibleWorkspacesRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 35);

/**
 * @generated from message deployments.v1.ListAccessibleWorkspacesResponse
 */
export type ListAccessibleWorkspacesResponse = Message<"deployments.v1.ListAccessibleWorkspacesResponse"> & {
  /**
   * @generated from field: repeated deployments.v1.Workspace workspaces = 1;
   */
  workspaces: Workspace[];

  /**
   * Always empty — page-number pagination is used instead, matching
   * ListWorkspacesResponse's own handler, which never populates this
   * either. Kept only for shape parity.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total number of workspaces matching the current search/filter/rules.
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message deployments.v1.ListAccessibleWorkspacesResponse.
 * Use `create(ListAccessibleWorkspacesResponseSchema)` to create a new message.
 */
export const ListAccessibleWorkspacesResponseSchema: GenMessage<ListAccessibleWorkspacesResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 36);

/**
 * @generated from message deployments.v1.DeleteWorkspaceRequest
 */
export type DeleteWorkspaceRequest = Message<"deployments.v1.DeleteWorkspaceRequest"> & {
  /**
   * The workspace to deprovision.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Controls how the workspace is deleted.
   *
   * @generated from field: deployments.v1.DeleteMode mode = 2;
   */
  mode: DeleteMode;
};

/**
 * Describes the message deployments.v1.DeleteWorkspaceRequest.
 * Use `create(DeleteWorkspaceRequestSchema)` to create a new message.
 */
export const DeleteWorkspaceRequestSchema: GenMessage<DeleteWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 37);

/**
 * @generated from message deployments.v1.DeleteWorkspaceResponse
 */
export type DeleteWorkspaceResponse = Message<"deployments.v1.DeleteWorkspaceResponse"> & {
};

/**
 * Describes the message deployments.v1.DeleteWorkspaceResponse.
 * Use `create(DeleteWorkspaceResponseSchema)` to create a new message.
 */
export const DeleteWorkspaceResponseSchema: GenMessage<DeleteWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 38);

/**
 * UpdateWorkspaceClusterNameRequest sets the Kubernetes cluster name on a
 * workspace. This is independent of deployment — it can be set at any time
 * before triggering service deployment.
 *
 * @generated from message deployments.v1.UpdateWorkspaceClusterNameRequest
 */
export type UpdateWorkspaceClusterNameRequest = Message<"deployments.v1.UpdateWorkspaceClusterNameRequest"> & {
  /**
   * The workspace to update.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The Kubernetes cluster name for ArgoCD routing.
   * Example: "uniphore.teleport.sh-uniphore-dev-us-eks-platform"
   *
   * @generated from field: string cluster_name = 2;
   */
  clusterName: string;
};

/**
 * Describes the message deployments.v1.UpdateWorkspaceClusterNameRequest.
 * Use `create(UpdateWorkspaceClusterNameRequestSchema)` to create a new message.
 */
export const UpdateWorkspaceClusterNameRequestSchema: GenMessage<UpdateWorkspaceClusterNameRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 39);

/**
 * @generated from message deployments.v1.UpdateWorkspaceClusterNameResponse
 */
export type UpdateWorkspaceClusterNameResponse = Message<"deployments.v1.UpdateWorkspaceClusterNameResponse"> & {
  /**
   * The workspace with the updated cluster_name.
   *
   * @generated from field: deployments.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;
};

/**
 * Describes the message deployments.v1.UpdateWorkspaceClusterNameResponse.
 * Use `create(UpdateWorkspaceClusterNameResponseSchema)` to create a new message.
 */
export const UpdateWorkspaceClusterNameResponseSchema: GenMessage<UpdateWorkspaceClusterNameResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 40);

/**
 * ListAvailableReleasesRequest returns releases available for upgrading a workspace.
 *
 * @generated from message deployments.v1.ListAvailableReleasesRequest
 */
export type ListAvailableReleasesRequest = Message<"deployments.v1.ListAvailableReleasesRequest"> & {
  /**
   * The workspace to check. Its current_release_id is used as the lower bound.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: filter by application group (e.g. "baic").
   *
   * @generated from field: string release_group = 2;
   */
  releaseGroup: string;
};

/**
 * Describes the message deployments.v1.ListAvailableReleasesRequest.
 * Use `create(ListAvailableReleasesRequestSchema)` to create a new message.
 */
export const ListAvailableReleasesRequestSchema: GenMessage<ListAvailableReleasesRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 41);

/**
 * ListAvailableReleasesResponse contains releases newer than the workspace's
 * current release, excluding deprecated ones.
 *
 * @generated from message deployments.v1.ListAvailableReleasesResponse
 */
export type ListAvailableReleasesResponse = Message<"deployments.v1.ListAvailableReleasesResponse"> & {
  /**
   * @generated from field: repeated releases.v1.Release releases = 1;
   */
  releases: Release[];
};

/**
 * Describes the message deployments.v1.ListAvailableReleasesResponse.
 * Use `create(ListAvailableReleasesResponseSchema)` to create a new message.
 */
export const ListAvailableReleasesResponseSchema: GenMessage<ListAvailableReleasesResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 42);

/**
 * PromoteReleaseRequest actually applies a release to a workspace's cluster -
 * either a refresh of the current release's just-synced manifest (release_id
 * empty), or an upgrade to a different, already-published release
 * (release_id set). Dispatches weekly_release_promote.yml and returns
 * immediately; the promote itself runs asynchronously - track it via the
 * workspace's upgrade_status and the workspace's audit history.
 *
 * @generated from message deployments.v1.PromoteReleaseRequest
 */
export type PromoteReleaseRequest = Message<"deployments.v1.PromoteReleaseRequest"> & {
  /**
   * The workspace to promote.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: a different release to promote to. Must exist and must not be
   * deprecated. Empty means "re-apply a refresh of the current release".
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 2;
   */
  releaseId: string;

  /**
   * Optional: run Liquibase database migrations as part of this promote.
   * Defaults to false.
   *
   * @generated from field: bool run_liquibase = 3;
   */
  runLiquibase: boolean;
};

/**
 * Describes the message deployments.v1.PromoteReleaseRequest.
 * Use `create(PromoteReleaseRequestSchema)` to create a new message.
 */
export const PromoteReleaseRequestSchema: GenMessage<PromoteReleaseRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 43);

/**
 * PromoteReleaseResponse returns the workspace immediately after the promote
 * workflow has been dispatched (upgrade_status = IN_PROGRESS, target_release_id
 * set) - it does not wait for the workflow to finish.
 *
 * @generated from message deployments.v1.PromoteReleaseResponse
 */
export type PromoteReleaseResponse = Message<"deployments.v1.PromoteReleaseResponse"> & {
  /**
   * @generated from field: deployments.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;
};

/**
 * Describes the message deployments.v1.PromoteReleaseResponse.
 * Use `create(PromoteReleaseResponseSchema)` to create a new message.
 */
export const PromoteReleaseResponseSchema: GenMessage<PromoteReleaseResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 44);

/**
 * PromoteReleaseMultiRequest fans a release promote out across every named
 * workspace in one batch (release_promote_multi.yml via the
 * releasepromotemulti Temporal workflow), all promoted to the same
 * release_id. Every workspace_id must currently share the same
 * current_release_id and belong to the same deployment - rejected with
 * FailedPrecondition, naming every offending workspace, otherwise. Unlike
 * PromoteReleaseRequest, release_id is required: there's no single "refresh
 * whatever's already running" target when multiple workspaces are involved.
 *
 * @generated from message deployments.v1.PromoteReleaseMultiRequest
 */
export type PromoteReleaseMultiRequest = Message<"deployments.v1.PromoteReleaseMultiRequest"> & {
  /**
   * The workspaces to promote, all on the same deployment and current release.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: repeated string workspace_ids = 1;
   */
  workspaceIds: string[];

  /**
   * The release every named workspace is promoted to. Required.
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 2;
   */
  releaseId: string;

  /**
   * Optional: the Terraform operation to forward to release_promote_multi.yml
   * for every workspace in the batch - "plan" or "apply". Empty defaults to
   * "apply" (mirrors PromoteMultiInput.TerraformOperation's own default).
   *
   * @generated from field: string terraform_operation = 3;
   */
  terraformOperation: string;

  /**
   * Optional: run Liquibase database migrations as part of this promote for
   * every workspace in the batch. Defaults to false.
   *
   * @generated from field: bool run_liquibase = 4;
   */
  runLiquibase: boolean;
};

/**
 * Describes the message deployments.v1.PromoteReleaseMultiRequest.
 * Use `create(PromoteReleaseMultiRequestSchema)` to create a new message.
 */
export const PromoteReleaseMultiRequestSchema: GenMessage<PromoteReleaseMultiRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 45);

/**
 * PromoteReleaseMultiResponse carries the deterministic Temporal workflow ID
 * for this dispatch (release-promote-multi-<deployment_id>) and the server
 * time the dispatch succeeded - mirrors RunReleasePlanResponse's shape, since
 * this handler (like RunReleasePlan) never synchronously mutates any
 * workspace row itself; PromoteMultiWorkflow's PrepareTenantsActivity does
 * that per-tenant, asynchronously. Track progress via each workspace's
 * upgrade_status and audit history.
 *
 * @generated from message deployments.v1.PromoteReleaseMultiResponse
 */
export type PromoteReleaseMultiResponse = Message<"deployments.v1.PromoteReleaseMultiResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Unix milliseconds; 0 on the rare WorkflowExecutionAlreadyStarted race
   * (mirrors RunReleasePlanResponse.dispatched_at_ms).
   *
   * @generated from field: int64 dispatched_at_ms = 2;
   */
  dispatchedAtMs: bigint;

  /**
   * Echoes back the workspace_ids this dispatch was accepted for.
   *
   * @generated from field: repeated string workspace_ids = 3;
   */
  workspaceIds: string[];
};

/**
 * Describes the message deployments.v1.PromoteReleaseMultiResponse.
 * Use `create(PromoteReleaseMultiResponseSchema)` to create a new message.
 */
export const PromoteReleaseMultiResponseSchema: GenMessage<PromoteReleaseMultiResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 46);

/**
 * RunReleasePlanRequest dispatches weekly_release_promote.yml with
 * terraform_operation=plan - a real Terraform dry-run against the target
 * release, no commit/PR/apply. Purely ephemeral: unlike PromoteRelease, this
 * never mutates workspace.upgrade_status and records no audit event - see
 * docs/design/005-release-sync-and-promote.md.
 *
 * @generated from message deployments.v1.RunReleasePlanRequest
 */
export type RunReleasePlanRequest = Message<"deployments.v1.RunReleasePlanRequest"> & {
  /**
   * The workspace to plan against.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: plan a different, already-published release. Empty means "plan
   * a refresh of the current release" (mirrors PromoteReleaseRequest).
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 2;
   */
  releaseId: string;

  /**
   * Optional: run Liquibase database migrations (as a dry-run preview) as
   * part of this plan. Defaults to false.
   *
   * @generated from field: bool run_liquibase = 3;
   */
  runLiquibase: boolean;
};

/**
 * Describes the message deployments.v1.RunReleasePlanRequest.
 * Use `create(RunReleasePlanRequestSchema)` to create a new message.
 */
export const RunReleasePlanRequestSchema: GenMessage<RunReleasePlanRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 47);

/**
 * RunReleasePlanResponse carries the deterministic Temporal workflow ID for
 * this dispatch (release-plan-<workspace_id>) and the server time the
 * dispatch succeeded, both needed by
 * releases.v1.ReleasesService/StreamWorkflowRunEvents: the workflow ID is
 * reused across every Plan dispatch for a workspace, so dispatched_at_ms lets
 * the stream tell this run apart from a still-lingering, already-completed
 * prior one with the same ID.
 *
 * @generated from message deployments.v1.RunReleasePlanResponse
 */
export type RunReleasePlanResponse = Message<"deployments.v1.RunReleasePlanResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Unix milliseconds; 0 on the rare WorkflowExecutionAlreadyStarted race
   * (Temporal's at-most-one-open-execution guarantee makes any found run
   * unambiguous in that case, so no cutoff is needed).
   *
   * @generated from field: int64 dispatched_at_ms = 2;
   */
  dispatchedAtMs: bigint;
};

/**
 * Describes the message deployments.v1.RunReleasePlanResponse.
 * Use `create(RunReleasePlanResponseSchema)` to create a new message.
 */
export const RunReleasePlanResponseSchema: GenMessage<RunReleasePlanResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 48);

/**
 * DeployFromMainRequest dispatches deploy_from_main.yml for a single service
 * off an arbitrary branch - a targeted, ad-hoc deploy against the
 * workspace's live cluster, distinct from PromoteRelease/RunReleasePlan:
 * there is no release_id, and neither workspace.current_release_id nor
 * current_version is touched. Dispatches and returns immediately; the
 * deploy itself runs asynchronously - track it via the workspace's audit
 * history. See docs/design/006-deploy-from-main.md.
 *
 * @generated from message deployments.v1.DeployFromMainRequest
 */
export type DeployFromMainRequest = Message<"deployments.v1.DeployFromMainRequest"> & {
  /**
   * The workspace to deploy against.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: the x-forge-installer branch to dispatch deploy_from_main.yml
   * from. Empty means "the workspace's current release's branch" - requires
   * workspace.current_release_id be set (rejected with FailedPrecondition
   * otherwise, same as PromoteRelease's legacy-workspace check).
   *
   * @generated from field: string installer_branch = 2;
   */
  installerBranch: string;

  /**
   * The service to deploy. Required.
   *
   * @generated from field: string service_name = 3;
   */
  serviceName: string;

  /**
   * The branch of service_name to deploy. Required.
   *
   * @generated from field: string service_branch = 4;
   */
  serviceBranch: string;

  /**
   * Optional: Image tag to deploy if service_branch is not main or release/** branch
   *
   * @generated from field: string image_tag = 5;
   */
  imageTag: string;

  /**
   * Optional: Helm Chart version to deploy if service_branch is not main or release/** branch
   *
   * @generated from field: string chart_version = 6;
   */
  chartVersion: string;

  /**
   * Optional: refresh ingress as part of this deploy. Defaults to false.
   *
   * @generated from field: bool refresh_ingress = 7;
   */
  refreshIngress: boolean;

  /**
   * Optional: run Liquibase database migrations as part of this deploy.
   * Defaults to false.
   *
   * @generated from field: bool run_liquibase = 8;
   */
  runLiquibase: boolean;
};

/**
 * Describes the message deployments.v1.DeployFromMainRequest.
 * Use `create(DeployFromMainRequestSchema)` to create a new message.
 */
export const DeployFromMainRequestSchema: GenMessage<DeployFromMainRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 49);

/**
 * DeployFromMainResponse carries the deterministic Temporal workflow ID for
 * this dispatch (deploy-from-main-<workspace_id>) and the server time the
 * dispatch succeeded.
 *
 * @generated from message deployments.v1.DeployFromMainResponse
 */
export type DeployFromMainResponse = Message<"deployments.v1.DeployFromMainResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Unix milliseconds; 0 on the WorkflowExecutionAlreadyStarted race - unlike
   * RunReleasePlan, that race is rejected as ErrDeployInProgress rather than
   * attached to silently, so a caller never actually observes 0 in practice.
   *
   * @generated from field: int64 dispatched_at_ms = 2;
   */
  dispatchedAtMs: bigint;
};

/**
 * Describes the message deployments.v1.DeployFromMainResponse.
 * Use `create(DeployFromMainResponseSchema)` to create a new message.
 */
export const DeployFromMainResponseSchema: GenMessage<DeployFromMainResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 50);

/**
 * DeployMaiRequest dispatches deploy_mai_components.yml to deploy the MAI
 * component charts to a workspace (against the isolated terraform/mai root) -
 * a targeted, independently-versioned add-on deploy, distinct from
 * PromoteRelease/RunReleasePlan: there is no release_id, and neither
 * workspace.current_release_id nor current_version is touched. The MAI chart
 * set is owned by deploy_mai_components.yml, not here. Dispatches and returns
 * immediately; the deploy runs asynchronously - track it via the workspace's
 * audit history. See docs/design/008-deploy-mai.md.
 *
 * @generated from message deployments.v1.DeployMaiRequest
 */
export type DeployMaiRequest = Message<"deployments.v1.DeployMaiRequest"> & {
  /**
   * The workspace to deploy MAI against.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: the x-forge-installer branch to dispatch
   * deploy_mai_components.yml from. Empty means "the workspace's current
   * release's branch" - requires workspace.current_release_id be set (rejected
   * with FailedPrecondition otherwise, same as DeployFromMain).
   *
   * @generated from field: string installer_branch = 2;
   */
  installerBranch: string;
};

/**
 * Describes the message deployments.v1.DeployMaiRequest.
 * Use `create(DeployMaiRequestSchema)` to create a new message.
 */
export const DeployMaiRequestSchema: GenMessage<DeployMaiRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 51);

/**
 * DeployMaiResponse carries the deterministic Temporal workflow ID for this
 * dispatch (deploy-mai-<workspace_id>) and the server time the dispatch
 * succeeded.
 *
 * @generated from message deployments.v1.DeployMaiResponse
 */
export type DeployMaiResponse = Message<"deployments.v1.DeployMaiResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Unix milliseconds; the WorkflowExecutionAlreadyStarted race is rejected as
   * ErrDeployInProgress rather than attached to, so a caller never observes 0.
   *
   * @generated from field: int64 dispatched_at_ms = 2;
   */
  dispatchedAtMs: bigint;
};

/**
 * Describes the message deployments.v1.DeployMaiResponse.
 * Use `create(DeployMaiResponseSchema)` to create a new message.
 */
export const DeployMaiResponseSchema: GenMessage<DeployMaiResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 52);

/**
 * DeployBaisRequest dispatches sun_deploy_bais.yml (wrapping deploy_bais.yml)
 * to deploy ONLY the BAIS component services to a workspace, scoped via
 * -target - a targeted stack deploy against the workspace's live cluster,
 * distinct from PromoteRelease/RunReleasePlan: there is no release_id, and
 * neither workspace.current_release_id nor current_version is touched. The
 * BAIS service set lives in x-forge-installer's configs/bais-services.json,
 * not here. Dispatches and returns immediately; the deploy runs
 * asynchronously - track it via the workspace's audit history. See
 * docs/design/007-deploy-bais.md.
 *
 * @generated from message deployments.v1.DeployBaisRequest
 */
export type DeployBaisRequest = Message<"deployments.v1.DeployBaisRequest"> & {
  /**
   * The workspace to deploy BAIS against.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: the release to deploy BAIS services from. Empty means "the
   * workspace's current release" - requires workspace.current_release_id be
   * set (rejected with FailedPrecondition otherwise, same as DeployFromMain's
   * legacy-workspace check).
   *
   * @generated from field: string release_id = 4;
   */
  releaseId: string;
};

/**
 * Describes the message deployments.v1.DeployBaisRequest.
 * Use `create(DeployBaisRequestSchema)` to create a new message.
 */
export const DeployBaisRequestSchema: GenMessage<DeployBaisRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 53);

/**
 * DeployBaisResponse carries the deterministic Temporal workflow ID for this
 * dispatch (deploy-bais-<workspace_id>) and the server time the dispatch
 * succeeded.
 *
 * @generated from message deployments.v1.DeployBaisResponse
 */
export type DeployBaisResponse = Message<"deployments.v1.DeployBaisResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Unix milliseconds; the WorkflowExecutionAlreadyStarted race is rejected as
   * ErrDeployInProgress rather than attached to, so a caller never observes 0.
   *
   * @generated from field: int64 dispatched_at_ms = 2;
   */
  dispatchedAtMs: bigint;
};

/**
 * Describes the message deployments.v1.DeployBaisResponse.
 * Use `create(DeployBaisResponseSchema)` to create a new message.
 */
export const DeployBaisResponseSchema: GenMessage<DeployBaisResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 54);

/**
 * StreamWorkspaceEventsRequest subscribes to lifecycle events for a single
 * workspace. The stream stays open until the client disconnects.
 *
 * @generated from message deployments.v1.StreamWorkspaceEventsRequest
 */
export type StreamWorkspaceEventsRequest = Message<"deployments.v1.StreamWorkspaceEventsRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message deployments.v1.StreamWorkspaceEventsRequest.
 * Use `create(StreamWorkspaceEventsRequestSchema)` to create a new message.
 */
export const StreamWorkspaceEventsRequestSchema: GenMessage<StreamWorkspaceEventsRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 55);

/**
 * StreamWorkspaceEventsResponse is one event pushed to the UI.
 *
 * @generated from message deployments.v1.StreamWorkspaceEventsResponse
 */
export type StreamWorkspaceEventsResponse = Message<"deployments.v1.StreamWorkspaceEventsResponse"> & {
  /**
   * Raw JSON payload from pg_notify. Possible shapes:
   *   {"event_type":"workspace.status_changed","workspace_id":"...","status":"...","timestamp_ms":...}
   *   {"event_type":"workspace.audit_event","workspace_id":"...","audit_id":"...","timestamp_ms":...}
   *   {"event_type":"workspace.workflow_run_changed","workspace_id":"...","run_id":"...","status":"...","timestamp_ms":...}
   *   {"event_type":"keepalive"}
   *
   * @generated from field: string payload = 1;
   */
  payload: string;
};

/**
 * Describes the message deployments.v1.StreamWorkspaceEventsResponse.
 * Use `create(StreamWorkspaceEventsResponseSchema)` to create a new message.
 */
export const StreamWorkspaceEventsResponseSchema: GenMessage<StreamWorkspaceEventsResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 56);

/**
 * GetLastWorkspaceWorkflowRunRequest looks up the most recent workflow_runs row for a
 * workspace, optionally scoped to one specific kind of workflow via `scope`.
 * A pure DB read - never dispatches anything.
 *
 * @generated from message deployments.v1.GetLastWorkspaceWorkflowRunRequest
 */
export type GetLastWorkspaceWorkflowRunRequest = Message<"deployments.v1.GetLastWorkspaceWorkflowRunRequest"> & {
  /**
   * The workspace whose last workflow run to look up.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "" (default) returns the workspace's last run of ANY kind - the
   * page-level "is anything in flight / what last happened" banner case.
   * "release_plan" scopes to the workspace's release-plan dry run
   * specifically (release-plan-<workspace_id>), replacing the old
   * GetLatestReleasePlanRun - resolved server-side to the deterministic
   * workflow ID, so the frontend never constructs that convention itself.
   * Future scopes (e.g. a per-kind lookup for a workflow-runs tab) can be
   * added the same way without a new RPC. Unknown non-empty values are
   * rejected with InvalidArgument.
   *
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message deployments.v1.GetLastWorkspaceWorkflowRunRequest.
 * Use `create(GetLastWorkspaceWorkflowRunRequestSchema)` to create a new message.
 */
export const GetLastWorkspaceWorkflowRunRequestSchema: GenMessage<GetLastWorkspaceWorkflowRunRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 57);

/**
 * GetLastWorkspaceWorkflowRunResponse reports the resolved run, if any and if still
 * worth showing. found=false covers "never run" and "the only run on record
 * is terminal and older than the freshness window" - the frontend does not
 * need to distinguish those two cases.
 *
 * A run that is still in progress is ALWAYS returned regardless of age -
 * staleness only gates a *finished* run, since an in-progress run is live by
 * definition and has no "how old is this" question to ask.
 *
 * @generated from message deployments.v1.GetLastWorkspaceWorkflowRunResponse
 */
export type GetLastWorkspaceWorkflowRunResponse = Message<"deployments.v1.GetLastWorkspaceWorkflowRunResponse"> & {
  /**
   * True if a run exists and is either in progress or finished within the
   * freshness window. All other fields are unset when false.
   *
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * Deterministic Temporal workflow ID - feed straight into
   * releases.v1.ReleasesService/StreamWorkflowRunEvents for live output.
   *
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * The found run's own created_at, in Unix milliseconds - pass this as
   * StreamWorkflowRunEventsRequest.since_ms so the stream resolves back to
   * this exact row rather than a possible newer dispatch racing this call.
   *
   * @generated from field: int64 since_ms = 3;
   */
  sinceMs: bigint;

  /**
   * Raw workflow_runs.kind value: "bootstrap" | "workspace" | "release".
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * The dispatched GitHub Actions workflow file, e.g. "deploy_bais.yml",
   * "deploy_mai_components.yml", "weekly_release_promote.yml".
   *
   * @generated from field: string workflow = 5;
   */
  workflow: string;

  /**
   * Raw workflow_runs.status value: "in_progress" | "completed".
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * Raw workflow_runs.conclusion value ("success" | "failure" | "cancelled"
   * | "skipped"). Unset while status == "in_progress".
   *
   * @generated from field: string conclusion = 7;
   */
  conclusion: string;

  /**
   * When the run started (workflow_runs.started_at).
   *
   * @generated from field: google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp;

  /**
   * When the run finished (workflow_runs.completed_at). Unset while running.
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 9;
   */
  completedAt?: Timestamp;

  /**
   * The release this run relates to (workflow_runs.release_id), when set.
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 10;
   */
  releaseId: string;

  /**
   * Direct URL to the GitHub Actions run page.
   *
   * @generated from field: string run_url = 11;
   */
  runUrl: string;
};

/**
 * Describes the message deployments.v1.GetLastWorkspaceWorkflowRunResponse.
 * Use `create(GetLastWorkspaceWorkflowRunResponseSchema)` to create a new message.
 */
export const GetLastWorkspaceWorkflowRunResponseSchema: GenMessage<GetLastWorkspaceWorkflowRunResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 58);

/**
 * MicroserviceChange describes one microservice's before/after state in a
 * release manifest diff. For an added service, the old_* fields are empty;
 * for a removed service, the new_* fields are empty (see
 * ReleaseDiff.removed). git_repo and chart_name are descriptive
 * (not diffed) context pulled from whichever side of the change has them.
 *
 * @generated from message deployments.v1.MicroserviceChange
 */
export type MicroserviceChange = Message<"deployments.v1.MicroserviceChange"> & {
  /**
   * @generated from field: string service = 1;
   */
  service: string;

  /**
   * @generated from field: string old_docker_image = 2;
   */
  oldDockerImage: string;

  /**
   * @generated from field: string new_docker_image = 3;
   */
  newDockerImage: string;

  /**
   * @generated from field: string old_chart_version = 4;
   */
  oldChartVersion: string;

  /**
   * @generated from field: string new_chart_version = 5;
   */
  newChartVersion: string;

  /**
   * @generated from field: string old_commit_sha = 6;
   */
  oldCommitSha: string;

  /**
   * @generated from field: string new_commit_sha = 7;
   */
  newCommitSha: string;

  /**
   * @generated from field: string git_repo = 8;
   */
  gitRepo: string;

  /**
   * @generated from field: string chart_name = 9;
   */
  chartName: string;
};

/**
 * Describes the message deployments.v1.MicroserviceChange.
 * Use `create(MicroserviceChangeSchema)` to create a new message.
 */
export const MicroserviceChangeSchema: GenMessage<MicroserviceChange> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 59);

/**
 * ReleaseInfo carries the refreshed manifest's own top-level metadata for
 * display context - version, branch, hotfix flag, comment, and start date.
 * Not diffed against a prior state; always reflects the manifest being
 * synced to.
 *
 * @generated from message deployments.v1.ReleaseInfo
 */
export type ReleaseInfo = Message<"deployments.v1.ReleaseInfo"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: bool is_hotfix = 2;
   */
  isHotfix: boolean;

  /**
   * @generated from field: string branch = 3;
   */
  branch: string;

  /**
   * @generated from field: string comment = 4;
   */
  comment: string;

  /**
   * @generated from field: string start_date = 5;
   */
  startDate: string;

  /**
   * @generated from field: string finish_date = 6;
   */
  finishDate: string;
};

/**
 * Describes the message deployments.v1.ReleaseInfo.
 * Use `create(ReleaseInfoSchema)` to create a new message.
 */
export const ReleaseInfoSchema: GenMessage<ReleaseInfo> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 60);

/**
 * DeployedComponent describes one microservice as actually deployed in a
 * workspace right now. Unlike MicroserviceChange this is single-sided - not
 * diffed against a prior or later state.
 *
 * @generated from message deployments.v1.DeployedComponent
 */
export type DeployedComponent = Message<"deployments.v1.DeployedComponent"> & {
  /**
   * @generated from field: string service = 1;
   */
  service: string;

  /**
   * @generated from field: string docker_image = 2;
   */
  dockerImage: string;

  /**
   * @generated from field: string chart_version = 3;
   */
  chartVersion: string;

  /**
   * @generated from field: string chart_name = 4;
   */
  chartName: string;

  /**
   * @generated from field: string commit_sha = 5;
   */
  commitSha: string;

  /**
   * @generated from field: string git_repo = 6;
   */
  gitRepo: string;
};

/**
 * Describes the message deployments.v1.DeployedComponent.
 * Use `create(DeployedComponentSchema)` to create a new message.
 */
export const DeployedComponentSchema: GenMessage<DeployedComponent> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 61);

/**
 * DeployedReleaseManifest is a workspace's release_metadata snapshot - the
 * full manifest captured at its last successful PromoteRelease, describing
 * exactly what's deployed right now. Populated only by GetWorkspace, never
 * ListWorkspaces. Unset when the workspace has never completed a promote
 * since release tracking (release_metadata) shipped.
 *
 * @generated from message deployments.v1.DeployedReleaseManifest
 */
export type DeployedReleaseManifest = Message<"deployments.v1.DeployedReleaseManifest"> & {
  /**
   * @generated from field: deployments.v1.ReleaseInfo release_info = 1;
   */
  releaseInfo?: ReleaseInfo;

  /**
   * @generated from field: repeated deployments.v1.DeployedComponent components = 2;
   */
  components: DeployedComponent[];

  /**
   * The shared xforge-db platform component. Unset if the manifest has no
   * xforge-db entry.
   *
   * @generated from field: deployments.v1.DeployedComponent platform_db = 3;
   */
  platformDb?: DeployedComponent;
};

/**
 * Describes the message deployments.v1.DeployedReleaseManifest.
 * Use `create(DeployedReleaseManifestSchema)` to create a new message.
 */
export const DeployedReleaseManifestSchema: GenMessage<DeployedReleaseManifest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 62);

/**
 * ReleaseDiff is the result of comparing a workspace's currently-deployed
 * release metadata against a freshly-synced manifest.
 *
 * @generated from message deployments.v1.ReleaseDiff
 */
export type ReleaseDiff = Message<"deployments.v1.ReleaseDiff"> & {
  /**
   * The refreshed manifest's own release metadata (version, branch, hotfix, comment, date).
   *
   * @generated from field: deployments.v1.ReleaseInfo release = 5;
   */
  release?: ReleaseInfo;

  /**
   * Services present in the new manifest but not in the workspace's current metadata.
   *
   * @generated from field: repeated deployments.v1.MicroserviceChange added = 1;
   */
  added: MicroserviceChange[];

  /**
   * Services present in both, with at least one of image/chart/commit/chart-name differing.
   *
   * @generated from field: repeated deployments.v1.MicroserviceChange changed = 2;
   */
  changed: MicroserviceChange[];

  /**
   * Services present in the workspace's current metadata but absent from the new
   * manifest. Only the old_* fields are populated.
   *
   * @generated from field: repeated deployments.v1.MicroserviceChange removed = 3;
   */
  removed: MicroserviceChange[];

  /**
   * The manifest's shared xforge-db platform component, populated only when its
   * commit sha changed between the baseline and the refreshed manifest. Unset
   * (nil) when unchanged.
   *
   * @generated from field: deployments.v1.MicroserviceChange platform_db_change = 4;
   */
  platformDbChange?: MicroserviceChange;
};

/**
 * Describes the message deployments.v1.ReleaseDiff.
 * Use `create(ReleaseDiffSchema)` to create a new message.
 */
export const ReleaseDiffSchema: GenMessage<ReleaseDiff> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 63);

/**
 * PreviewReleaseDiffRequest computes a diff between a workspace's deployed
 * manifest and a target release's already-synced manifest. Purely a DB
 * read - dispatches nothing. If the target release has never been synced or
 * its sync is stale, returns RELEASE_DIFF_STATUS_SYNC_NEEDED instead of a
 * diff; the caller must dispatch SyncRelease first.
 *
 * @generated from message deployments.v1.PreviewReleaseDiffRequest
 */
export type PreviewReleaseDiffRequest = Message<"deployments.v1.PreviewReleaseDiffRequest"> & {
  /**
   * The workspace to sync.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * Optional: a different release to preview upgrading to. Must exist and
   * must not be deprecated. Empty means "preview a refresh of the
   * workspace's current release" (dispatches weekly_release_sync.yml).
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 2;
   */
  releaseId: string;
};

/**
 * Describes the message deployments.v1.PreviewReleaseDiffRequest.
 * Use `create(PreviewReleaseDiffRequestSchema)` to create a new message.
 */
export const PreviewReleaseDiffRequestSchema: GenMessage<PreviewReleaseDiffRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 64);

/**
 * PreviewReleaseDiffResponse carries the computed diff, a failure reason, or
 * a sync-needed signal.
 *
 * @generated from message deployments.v1.PreviewReleaseDiffResponse
 */
export type PreviewReleaseDiffResponse = Message<"deployments.v1.PreviewReleaseDiffResponse"> & {
  /**
   * @generated from field: deployments.v1.ReleaseDiffStatus status = 1;
   */
  status: ReleaseDiffStatus;

  /**
   * @generated from field: deployments.v1.ReleaseDiff diff = 2;
   */
  diff?: ReleaseDiff;

  /**
   * Populated when status is FAILED.
   *
   * @generated from field: string error_message = 3;
   */
  errorMessage: string;

  /**
   * The target release's current sync state - always populated regardless
   * of status, so the UI can render "last synced Xm ago" without a second call.
   *
   * @generated from field: releases.v1.ReleaseSyncStatus sync_status = 4;
   */
  syncStatus: ReleaseSyncStatus;

  /**
   * When the target release's manifest was last successfully synced. Unset
   * if sync_status is NONE.
   *
   * @generated from field: google.protobuf.Timestamp last_synced_at = 5;
   */
  lastSyncedAt?: Timestamp;

  /**
   * The target release's own record, always populated regardless of
   * status. Prefer reading from here for anything about the release itself
   * (sync_error, approval_status, etc.) instead of adding another
   * individual field to this message each time the UI needs one more.
   *
   * @generated from field: releases.v1.Release target_release = 7;
   */
  targetRelease?: Release;
};

/**
 * Describes the message deployments.v1.PreviewReleaseDiffResponse.
 * Use `create(PreviewReleaseDiffResponseSchema)` to create a new message.
 */
export const PreviewReleaseDiffResponseSchema: GenMessage<PreviewReleaseDiffResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 65);

/**
 * PreflightCheck is one verified requirement in the preflight report.
 *
 * @generated from message deployments.v1.PreflightCheck
 */
export type PreflightCheck = Message<"deployments.v1.PreflightCheck"> & {
  /**
   * Stable identifier for the check (e.g. "aws_secret:duploservices-acme-a8-runtime").
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Grouping label for display (e.g. "Secrets", "Database", "DNS", "DuploCloud", "CI/CD").
   *
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * Human-readable, internationalized one-line title.
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: deployments.v1.PreflightSeverity severity = 4;
   */
  severity: PreflightSeverity;

  /**
   * @generated from field: deployments.v1.PreflightStatus status = 5;
   */
  status: PreflightStatus;

  /**
   * Detail about the result (e.g. "secret not found in us-east-2").
   *
   * @generated from field: string detail = 6;
   */
  detail: string;

  /**
   * Internationalized remediation guidance shown when the check is not PASS.
   *
   * @generated from field: string remediation = 7;
   */
  remediation: string;

  /**
   * Resource/check type for display, e.g. "aws_secret", "route53_zone", or the
   * underlying Terraform type for wrapped kinds ("aws_s3_bucket",
   * "duplocloud_tenant"). Shown as a "<type>:<name>" prefix.
   *
   * @generated from field: string type = 8;
   */
  type: string;

  /**
   * Provenance of the requirement, e.g. "terraform:terraform/a8-apps/main.tf",
   * "rule:a8-runtime-secret", "chart:<path>". Shown as "Required in:".
   *
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * Concrete resource names behind the result (e.g. the buckets an assert_absent
   * check matched). Rendered as a bullet list under detail; detail carries the
   * count/summary.
   *
   * @generated from field: repeated string items = 10;
   */
  items: string[];
};

/**
 * Describes the message deployments.v1.PreflightCheck.
 * Use `create(PreflightCheckSchema)` to create a new message.
 */
export const PreflightCheckSchema: GenMessage<PreflightCheck> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 66);

/**
 * RunWorkspacePreflightRequest asks the server to compile the install
 * requirements for a workspace and verify them against the live backends.
 *
 * @generated from message deployments.v1.RunWorkspacePreflightRequest
 */
export type RunWorkspacePreflightRequest = Message<"deployments.v1.RunWorkspacePreflightRequest"> & {
  /**
   * Deployment the workspace belongs to.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * The workspace slug (used as infra_name), to scope template expansion.
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * Optional release to preflight against. If empty, the deployment's current
   * release is used.
   * Format: rel_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string release_id = 3;
   */
  releaseId: string;

  /**
   * Debug/preview only: compile the requirement list but skip live verification,
   * returning every check as UNKNOWN. Not the normal path.
   *
   * @generated from field: bool static_only = 4;
   */
  staticOnly: boolean;

  /**
   * Which preflight evaluation to run. "install-scripts-scan" (the default when
   * empty) scans the x-forge-installer sources and verifies the extracted
   * requirements; "db" evaluates the rules in the preflight_checks table for the
   * requested scope. Carried from the UI's preflightMode flag.
   *
   * @generated from field: string mode = 5;
   */
  mode: string;

  /**
   * The preflight_checks.scope to evaluate when mode is "db" (e.g. "teardown").
   * Ignored for "install-scripts-scan". Carried from the UI's preflightScope flag.
   *
   * @generated from field: string scope = 6;
   */
  scope: string;
};

/**
 * Describes the message deployments.v1.RunWorkspacePreflightRequest.
 * Use `create(RunWorkspacePreflightRequestSchema)` to create a new message.
 */
export const RunWorkspacePreflightRequestSchema: GenMessage<RunWorkspacePreflightRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 67);

/**
 * RunWorkspacePreflightResponse acknowledges that a preflight run has started.
 * The run is asynchronous (the workflow outlasts the HTTP write timeout); the
 * caller polls GetWorkspacePreflightStatus with the same (deployment, slug) to
 * retrieve the report.
 *
 * @generated from message deployments.v1.RunWorkspacePreflightResponse
 */
export type RunWorkspacePreflightResponse = Message<"deployments.v1.RunWorkspacePreflightResponse"> & {
  /**
   * Deterministic workflow id (keyed per deployment+slug) to poll on.
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * The run status at start time (RUNNING).
   *
   * @generated from field: deployments.v1.PreflightRunStatus status = 2;
   */
  status: PreflightRunStatus;
};

/**
 * Describes the message deployments.v1.RunWorkspacePreflightResponse.
 * Use `create(RunWorkspacePreflightResponseSchema)` to create a new message.
 */
export const RunWorkspacePreflightResponseSchema: GenMessage<RunWorkspacePreflightResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 68);

/**
 * GetWorkspacePreflightStatusRequest polls the status (and, once finished, the
 * report) of the preflight run for a workspace, keyed per (deployment, slug).
 *
 * @generated from message deployments.v1.GetWorkspacePreflightStatusRequest
 */
export type GetWorkspacePreflightStatusRequest = Message<"deployments.v1.GetWorkspacePreflightStatusRequest"> & {
  /**
   * Deployment the workspace belongs to.
   * Format: deploy_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * The workspace slug (used as infra_name).
   *
   * @generated from field: string slug = 2;
   */
  slug: string;
};

/**
 * Describes the message deployments.v1.GetWorkspacePreflightStatusRequest.
 * Use `create(GetWorkspacePreflightStatusRequestSchema)` to create a new message.
 */
export const GetWorkspacePreflightStatusRequestSchema: GenMessage<GetWorkspacePreflightStatusRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 69);

/**
 * GetWorkspacePreflightStatusResponse carries the run status and, when
 * COMPLETED, the compiled-and-verified preflight report.
 *
 * @generated from message deployments.v1.GetWorkspacePreflightStatusResponse
 */
export type GetWorkspacePreflightStatusResponse = Message<"deployments.v1.GetWorkspacePreflightStatusResponse"> & {
  /**
   * Current run status.
   *
   * @generated from field: deployments.v1.PreflightRunStatus status = 1;
   */
  status: PreflightRunStatus;

  /**
   * All checks, across every category. Populated when status == COMPLETED.
   *
   * @generated from field: repeated deployments.v1.PreflightCheck checks = 2;
   */
  checks: PreflightCheck[];

  /**
   * The overall gate decision derived from the checks (when COMPLETED).
   *
   * @generated from field: deployments.v1.PreflightOutcome outcome = 3;
   */
  outcome: PreflightOutcome;

  /**
   * Count of BLOCKER checks that failed. outcome == BLOCKED iff blockers > 0.
   *
   * @generated from field: int32 blockers = 4;
   */
  blockers: number;

  /**
   * Count of checks that could not be verified (UNKNOWN).
   *
   * @generated from field: int32 unknowns = 5;
   */
  unknowns: number;

  /**
   * Failure reason. Populated when status == FAILED.
   *
   * @generated from field: string error = 6;
   */
  error: string;
};

/**
 * Describes the message deployments.v1.GetWorkspacePreflightStatusResponse.
 * Use `create(GetWorkspacePreflightStatusResponseSchema)` to create a new message.
 */
export const GetWorkspacePreflightStatusResponseSchema: GenMessage<GetWorkspacePreflightStatusResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 70);

/**
 * RunAdHocPreflightRequest runs preflight against an ad-hoc AWS account BEFORE
 * any deployment exists (the pre-create idempotency gate on the New Deployment
 * page). The server resolves the cross-account role recorded for the account
 * (from a prior bootstrap) rather than taking it from the caller.
 *
 * @generated from message deployments.v1.RunAdHocPreflightRequest
 */
export type RunAdHocPreflightRequest = Message<"deployments.v1.RunAdHocPreflightRequest"> & {
  /**
   * Target AWS region (required). Also forces a single-region override so
   * regions:"all" checks don't sweep every region.
   *
   * @generated from field: string region = 1;
   */
  region: string;

  /**
   * Target AWS account id (required). Used to look up the recorded
   * aws_role_arn / aws_external_id in deployment_cloud_resources.
   *
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * The preflight_checks.scope to evaluate (db mode). Defaults to
   * "pre-deploy-deployment" when empty.
   *
   * @generated from field: string scope = 3;
   */
  scope: string;

  /**
   * Compile/preview only: skip live verification, returning every check UNKNOWN.
   *
   * @generated from field: bool static_only = 4;
   */
  staticOnly: boolean;
};

/**
 * Describes the message deployments.v1.RunAdHocPreflightRequest.
 * Use `create(RunAdHocPreflightRequestSchema)` to create a new message.
 */
export const RunAdHocPreflightRequestSchema: GenMessage<RunAdHocPreflightRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 71);

/**
 * GetAdHocPreflightStatusRequest polls an ad-hoc preflight run purely by its
 * workflow id (there is no deployment/slug to key on).
 *
 * @generated from message deployments.v1.GetAdHocPreflightStatusRequest
 */
export type GetAdHocPreflightStatusRequest = Message<"deployments.v1.GetAdHocPreflightStatusRequest"> & {
  /**
   * The workflow id returned by RunAdHocPreflight.
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message deployments.v1.GetAdHocPreflightStatusRequest.
 * Use `create(GetAdHocPreflightStatusRequestSchema)` to create a new message.
 */
export const GetAdHocPreflightStatusRequestSchema: GenMessage<GetAdHocPreflightStatusRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 72);

/**
 * RunAdHocPreflightResponse acknowledges that an ad-hoc preflight run started,
 * or carries an immediate verdict when no run is needed (new account, or the
 * recorded role can't be assumed). Mirrors RunWorkspacePreflightResponse plus a
 * message; distinct so each RPC owns its type.
 *
 * @generated from message deployments.v1.RunAdHocPreflightResponse
 */
export type RunAdHocPreflightResponse = Message<"deployments.v1.RunAdHocPreflightResponse"> & {
  /**
   * Workflow id to poll on. Empty when status is set immediately (no run).
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * RUNNING when a workflow was started; COMPLETED when an immediate verdict
   * (message) is returned without starting a run.
   *
   * @generated from field: deployments.v1.PreflightRunStatus status = 2;
   */
  status: PreflightRunStatus;

  /**
   * Human-readable verdict shown when no workflow was started (new account, or
   * the recorded role could not be assumed).
   *
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message deployments.v1.RunAdHocPreflightResponse.
 * Use `create(RunAdHocPreflightResponseSchema)` to create a new message.
 */
export const RunAdHocPreflightResponseSchema: GenMessage<RunAdHocPreflightResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 73);

/**
 * GetAdHocPreflightStatusResponse carries the run status and, when COMPLETED,
 * the verified report. Mirrors GetWorkspacePreflightStatusResponse.
 *
 * @generated from message deployments.v1.GetAdHocPreflightStatusResponse
 */
export type GetAdHocPreflightStatusResponse = Message<"deployments.v1.GetAdHocPreflightStatusResponse"> & {
  /**
   * Current run status.
   *
   * @generated from field: deployments.v1.PreflightRunStatus status = 1;
   */
  status: PreflightRunStatus;

  /**
   * All checks, across every category. Populated when status == COMPLETED.
   *
   * @generated from field: repeated deployments.v1.PreflightCheck checks = 2;
   */
  checks: PreflightCheck[];

  /**
   * The overall gate decision derived from the checks (when COMPLETED).
   *
   * @generated from field: deployments.v1.PreflightOutcome outcome = 3;
   */
  outcome: PreflightOutcome;

  /**
   * Count of BLOCKER checks that failed. outcome == BLOCKED iff blockers > 0.
   *
   * @generated from field: int32 blockers = 4;
   */
  blockers: number;

  /**
   * Count of checks that could not be verified (UNKNOWN).
   *
   * @generated from field: int32 unknowns = 5;
   */
  unknowns: number;

  /**
   * Failure reason. Populated when status == FAILED.
   *
   * @generated from field: string error = 6;
   */
  error: string;
};

/**
 * Describes the message deployments.v1.GetAdHocPreflightStatusResponse.
 * Use `create(GetAdHocPreflightStatusResponseSchema)` to create a new message.
 */
export const GetAdHocPreflightStatusResponseSchema: GenMessage<GetAdHocPreflightStatusResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 74);

/**
 * RetryWorkspaceProvisioningRequest identifies a workspace to retry provisioning for.
 *
 * @generated from message deployments.v1.RetryWorkspaceProvisioningRequest
 */
export type RetryWorkspaceProvisioningRequest = Message<"deployments.v1.RetryWorkspaceProvisioningRequest"> & {
  /**
   * The workspace to retry.
   * Format: workspace_[20 lowercase alphanumeric characters]
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message deployments.v1.RetryWorkspaceProvisioningRequest.
 * Use `create(RetryWorkspaceProvisioningRequestSchema)` to create a new message.
 */
export const RetryWorkspaceProvisioningRequestSchema: GenMessage<RetryWorkspaceProvisioningRequest> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 75);

/**
 * RetryWorkspaceProvisioningResponse returns the workspace in its updated state.
 *
 * @generated from message deployments.v1.RetryWorkspaceProvisioningResponse
 */
export type RetryWorkspaceProvisioningResponse = Message<"deployments.v1.RetryWorkspaceProvisioningResponse"> & {
  /**
   * @generated from field: deployments.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;
};

/**
 * Describes the message deployments.v1.RetryWorkspaceProvisioningResponse.
 * Use `create(RetryWorkspaceProvisioningResponseSchema)` to create a new message.
 */
export const RetryWorkspaceProvisioningResponseSchema: GenMessage<RetryWorkspaceProvisioningResponse> = /*@__PURE__*/
  messageDesc(file_deployments_v1_deployments, 76);

/**
 * DeploymentType indicates the cloud provider or on-prem infrastructure
 * where the customer's Data Plane runs.
 *
 * @generated from enum deployments.v1.DeploymentType
 */
export enum DeploymentType {
  /**
   * @generated from enum value: DEPLOYMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Amazon Web Services (EKS, RDS, S3, etc.)
   *
   * @generated from enum value: DEPLOYMENT_TYPE_CLOUD_AWS = 1;
   */
  CLOUD_AWS = 1,

  /**
   * Google Cloud Platform (GKE, Cloud SQL, GCS, etc.)
   *
   * @generated from enum value: DEPLOYMENT_TYPE_CLOUD_GCP = 2;
   */
  CLOUD_GCP = 2,

  /**
   * Microsoft Azure (AKS, Azure SQL, Blob Storage, etc.)
   *
   * @generated from enum value: DEPLOYMENT_TYPE_CLOUD_AZURE = 3;
   */
  CLOUD_AZURE = 3,

  /**
   * Customer-owned on-premises data center (vanilla Kubernetes).
   *
   * @generated from enum value: DEPLOYMENT_TYPE_ON_PREM = 4;
   */
  ON_PREM = 4,
}

/**
 * Describes the enum deployments.v1.DeploymentType.
 */
export const DeploymentTypeSchema: GenEnum<DeploymentType> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 0);

/**
 * DeploymentModel indicates the management and infrastructure relationship
 * for a BAIC deployment. Each model captures who manages the Management
 * Plane and whose infrastructure the workloads run in.
 *
 * Active models:
 *   HYBRID    — Uniphore-managed MP, customer infrastructure
 *   SAAS      — Uniphore-managed MP, Uniphore infrastructure
 *   AIRGAPPED — Customer-managed MP, customer infrastructure
 *
 * See requirements/docs/02-deployment-models.md for detailed descriptions.
 *
 * @generated from enum deployments.v1.DeploymentModel
 */
export enum DeploymentModel {
  /**
   * @generated from enum value: DEPLOYMENT_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Uniphore-managed Management Plane deploying into customer-owned
   * infrastructure. Uniphore operates the control/management planes;
   * the customer owns the cloud account and Data Plane resources.
   *
   * @generated from enum value: DEPLOYMENT_MODEL_HYBRID = 1;
   */
  HYBRID = 1,

  /**
   * Deprecated: use HYBRID or AIRGAPPED instead.
   *
   * @generated from enum value: DEPLOYMENT_MODEL_FULL_CUSTOMER_VPC = 2 [deprecated = true];
   * @deprecated
   */
  FULL_CUSTOMER_VPC = 2,

  /**
   * Deprecated: use AIRGAPPED instead.
   *
   * @generated from enum value: DEPLOYMENT_MODEL_ON_PREM = 3 [deprecated = true];
   * @deprecated
   */
  ON_PREM = 3,

  /**
   * Uniphore-managed Management Plane deploying into Uniphore-owned
   * infrastructure. Fully hosted by Uniphore — the customer has no
   * cloud account or bootstrap phase.
   *
   * @generated from enum value: DEPLOYMENT_MODEL_SAAS = 4;
   */
  SAAS = 4,

  /**
   * Customer-managed Management Plane deploying into customer-owned
   * infrastructure. The customer operates everything independently
   * with no connectivity back to Uniphore (air-gapped environments).
   *
   * @generated from enum value: DEPLOYMENT_MODEL_AIRGAPPED = 5;
   */
  AIRGAPPED = 5,
}

/**
 * Describes the enum deployments.v1.DeploymentModel.
 */
export const DeploymentModelSchema: GenEnum<DeploymentModel> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 1);

/**
 * DeploymentStatus represents the infrastructure lifecycle state of a
 * deployment. This tracks the deployment from initial creation through
 * cloud bootstrap, provisioning, and ongoing operations.
 *
 * Typical flow for cloud (BYOC) deployments:
 *   CREATED → AWAITING_BOOTSTRAP → PROVISIONING → PHASE_1_COMPLETE → PROVISIONED → ACTIVE
 *
 * MANAGEMENT_BLOCKED can occur whenever Sunstone loses the ability to assume
 * the customer's cross-account IAM role — at bootstrap or later during
 * provisioning/operations.
 *
 * The AWAITING_BOOTSTRAP state covers the period after the customer
 * launches the provider-specific bootstrap template (e.g. AWS
 * CloudFormation) and before the bootstrap callback Lambda delivers
 * credentials to the Management Plane. BOOTSTRAP_FAILED occurs if
 * pre-flight validation fails (subnet IP space, VPC DNS config,
 * AZ distribution, NAT routing) or the callback times out.
 *
 * For SaaS deployments the bootstrap phase is skipped:
 *   CREATED → PROVISIONING → ACTIVE
 *
 * See requirements/docs/08-platform-bootstrap-and-infrastructure-setup.md.
 *
 * @generated from enum deployments.v1.DeploymentStatus
 */
export enum DeploymentStatus {
  /**
   * @generated from enum value: DEPLOYMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Deployment record created; provider-specific bootstrap template
   * (e.g. CloudFormation) generated and available for the customer.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * Customer has launched the bootstrap template (e.g. CloudFormation);
   * awaiting credential callback from the validation/delivery Lambda.
   * The bootstrap template provisions security groups, IAM roles,
   * S3 buckets, and Lambda functions in the customer's account.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_AWAITING_BOOTSTRAP = 2;
   */
  AWAITING_BOOTSTRAP = 2,

  /**
   * Bootstrap pre-flight validation failed or callback timed out.
   * Common failures: insufficient subnet IP space (min 16 per subnet),
   * VPC DNS not enabled, missing NAT/IGW routing, insufficient AZ
   * distribution. The customer can retry by re-launching the template.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_BOOTSTRAP_FAILED = 3;
   */
  BOOTSTRAP_FAILED = 3,

  /**
   * Bootstrap callback received with IAM credentials and resource IDs;
   * Management Plane is provisioning infrastructure (EKS clusters,
   * networking, databases, etc.) via Control Plane and Crossplane.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_PROVISIONING = 4;
   */
  PROVISIONING = 4,

  /**
   * Deployment is fully operational. Workspaces can be created and
   * managed. Telemetry is flowing from Data Plane through Control
   * Plane to Management Plane.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_ACTIVE = 5;
   */
  ACTIVE = 5,

  /**
   * Deployment-wide maintenance in progress. This covers infrastructure
   * changes that affect all workspaces (e.g. Kubernetes version upgrades,
   * network reconfiguration, Control Plane migration). Individual
   * workspace BAIC upgrades do NOT set this — they use
   * WorkspaceUpgradeStatus instead.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_MAINTENANCE = 6;
   */
  MAINTENANCE = 6,

  /**
   * Deployment is deactivated (soft-deleted); data retained.
   * Reactivation is possible.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_INACTIVE = 7;
   */
  INACTIVE = 7,

  /**
   * Deployment is being deprovisioned. Cloud resources are being torn
   * down. On CloudFormation stack deletion, a cleanup Lambda notifies
   * the Management Plane for graceful teardown. The primary backup
   * S3 bucket is retained on stack deletion to protect artifacts.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_DEPROVISIONING = 8;
   */
  DEPROVISIONING = 8,

  /**
   * Bootstrap callback was not received within the expected time window
   * (typically 1 hour). The bootstrap token remains valid for its full
   * expiry period (typically 5 days) — if the callback arrives later,
   * the deployment transitions to PROVISIONING automatically.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_BOOTSTRAP_TIMEOUT = 9;
   */
  BOOTSTRAP_TIMEOUT = 9,

  /**
   * DuploCloud installation (Phase 2) is complete. DNS, certificates, and
   * all cloud infrastructure are fully provisioned. Transitions to ACTIVE
   * once post-provisioning validation finishes.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_PROVISIONED = 10;
   */
  PROVISIONED = 10,

  /**
   * Sunstone cannot assume the customer's cross-account IAM role and is
   * therefore unable to manage resources in the customer account. No
   * provisioning or operational actions can proceed until the customer
   * restores the required sts:AssumeRole trust (correct principal, ExternalId,
   * and permissions). Once access is restored the deployment can be
   * retried/reactivated.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_MANAGEMENT_BLOCKED = 11;
   */
  MANAGEMENT_BLOCKED = 11,

  /**
   * DNS and certificate provisioning (Phase 1) is complete. The deployment
   * is awaiting DuploCloud installation (Phase 2) before transitioning to
   * PROVISIONED.
   *
   * @generated from enum value: DEPLOYMENT_STATUS_PHASE_1_COMPLETE = 12;
   */
  PHASE_1_COMPLETE = 12,

  /**
   * DuploCloud CloudFormation stack is CREATE_COMPLETE; bootstrap admin token
   * has been read and zeroed; Entra redirect URI registered. Ready for
   * credential bootstrap (SUN-162).
   *
   * @generated from enum value: DEPLOYMENT_STATUS_PHASE_2_COMPLETE = 13;
   */
  PHASE_2_COMPLETE = 13,
}

/**
 * Describes the enum deployments.v1.DeploymentStatus.
 */
export const DeploymentStatusSchema: GenEnum<DeploymentStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 2);

/**
 * WorkspaceEnvironment identifies the purpose of a workspace within a
 * deployment. Each environment is a separate Kubernetes cluster in the
 * customer's infrastructure.
 *
 * BAIC platform upgrades flow sequentially through environments:
 * development → staging → production, with customer-controlled validation
 * periods between each stage.
 *
 * @generated from enum deployments.v1.WorkspaceEnvironment
 */
export enum WorkspaceEnvironment {
  /**
   * @generated from enum value: WORKSPACE_ENVIRONMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Customer's testing and development cluster. First to receive
   * platform upgrades from Uniphore.
   *
   * @generated from enum value: WORKSPACE_ENVIRONMENT_DEVELOPMENT = 1;
   */
  DEVELOPMENT = 1,

  /**
   * Customer's pre-production validation cluster. Receives upgrades
   * after the customer validates in development.
   *
   * @generated from enum value: WORKSPACE_ENVIRONMENT_STAGING = 2;
   */
  STAGING = 2,

  /**
   * Customer's business-critical production cluster. Last to receive
   * upgrades; customer can defer within version support policy limits.
   *
   * @generated from enum value: WORKSPACE_ENVIRONMENT_PRODUCTION = 3;
   */
  PRODUCTION = 3,
}

/**
 * Describes the enum deployments.v1.WorkspaceEnvironment.
 */
export const WorkspaceEnvironmentSchema: GenEnum<WorkspaceEnvironment> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 3);

/**
 * WorkspaceStatus represents the infrastructure lifecycle and operational
 * health of a workspace. This is independent of upgrade state — a workspace
 * can be HEALTHY while simultaneously having an upgrade scheduled or in
 * progress.
 *
 * Lifecycle flow:
 *   PROVISIONING → HEALTHY → INACTIVE
 *                → DEGRADED (partial issues detected)
 *                → UNAVAILABLE (critically impaired)
 *                → BLOCKED (management access lost)
 *
 * Health-based states (HEALTHY, DEGRADED, UNAVAILABLE) are determined by
 * Control Plane health checks and telemetry. BLOCKED is set by the
 * Management Plane when it detects credential or connectivity failures.
 *
 * See WorkspaceUpgradeStatus for the orthogonal upgrade state machine.
 *
 * @generated from enum deployments.v1.WorkspaceStatus
 */
export enum WorkspaceStatus {
  /**
   * @generated from enum value: WORKSPACE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Initial Kubernetes cluster provisioning in progress. The Control
   * Plane is creating the cluster, deploying BAIC components, and
   * establishing telemetry flows.
   *
   * @generated from enum value: WORKSPACE_STATUS_PROVISIONING = 1;
   */
  PROVISIONING = 1,

  /**
   * Workspace is fully operational. All health checks passing, serving
   * traffic normally, and reporting telemetry to the Control Plane.
   *
   * @generated from enum value: WORKSPACE_STATUS_HEALTHY = 2;
   */
  HEALTHY = 2,

  /**
   * Workspace is partially operational. Some components or health checks
   * are failing but the workspace is still serving traffic. Examples:
   * partial pod failures, elevated error rates, resource pressure
   * (CPU/memory approaching limits), or degraded telemetry flow.
   *
   * @generated from enum value: WORKSPACE_STATUS_DEGRADED = 3;
   */
  DEGRADED = 3,

  /**
   * Workspace is unreachable or critically impaired and cannot serve
   * traffic. Examples: cluster node failures, network partitions,
   * persistent CrashLoopBackOff across critical components, or complete
   * loss of telemetry.
   *
   * @generated from enum value: WORKSPACE_STATUS_UNAVAILABLE = 4;
   */
  UNAVAILABLE = 4,

  /**
   * Control Plane cannot manage this workspace. The IAM role assumption
   * or cross-account credentials required for the Control Plane to push
   * deployments and monitor the Data Plane have been revoked, expired,
   * or are otherwise invalid. The workspace may still be serving traffic
   * but Uniphore cannot apply upgrades, configuration changes, or
   * monitor health until access is restored. Customer action required.
   *
   * @generated from enum value: WORKSPACE_STATUS_BLOCKED = 5;
   */
  BLOCKED = 5,

  /**
   * Workspace is deactivated (soft-deleted); data retained.
   * Reactivation is possible.
   *
   * @generated from enum value: WORKSPACE_STATUS_INACTIVE = 6;
   */
  INACTIVE = 6,

  /**
   * Workspace Kubernetes cluster is being deprovisioned and cloud
   * resources are being torn down.
   *
   * @generated from enum value: WORKSPACE_STATUS_DEPROVISIONING = 7;
   */
  DEPROVISIONING = 7,

  /**
   * Infrastructure provisioning is complete and the workspace cluster exists,
   * but BAIC services have not yet been deployed.
   *
   * @generated from enum value: WORKSPACE_STATUS_PENDING_DEPLOYMENT = 8;
   */
  PENDING_DEPLOYMENT = 8,

  /**
   * Infrastructure provisioning failed. One or more steps (VPC, EKS, S3,
   * Helm ProviderConfig, or Teleport) did not complete. Check Temporal
   * workflow history for details. Re-provisioning may be attempted.
   *
   * @generated from enum value: WORKSPACE_STATUS_PROVISIONING_FAILED = 9;
   */
  PROVISIONING_FAILED = 9,

  /**
   * Infrastructure deprovisioning failed. One or more teardown steps did
   * not complete. Check Temporal workflow history for details.
   * Re-deprovisioning may be attempted by calling DeleteWorkspace again.
   *
   * @generated from enum value: WORKSPACE_STATUS_DEPROVISION_FAILED = 10;
   */
  DEPROVISION_FAILED = 10,
}

/**
 * Describes the enum deployments.v1.WorkspaceStatus.
 */
export const WorkspaceStatusSchema: GenEnum<WorkspaceStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 4);

/**
 * WorkspaceUpgradeStatus tracks the state of a BAIC platform upgrade
 * for a single workspace. This is orthogonal to WorkspaceStatus — the
 * workspace remains HEALTHY and serving traffic throughout the upgrade
 * lifecycle (rolling updates).
 *
 * Upgrade flow (orchestrated by Temporal workflows in Management Plane):
 *   NONE → SCHEDULED → IN_PROGRESS → COMPLETE → NONE
 *
 * Failure and rollback:
 *   IN_PROGRESS → FAILED → ROLLING_BACK → ROLLED_BACK → NONE
 *
 * Workspaces within a deployment are upgraded sequentially
 * (development → staging → production) with customer-controlled
 * validation periods between each. Customers can reschedule upgrades
 * within their assigned release wave window.
 *
 * Version support policy enforces a 90-day rolling window:
 *   N (current) — full support
 *   N-1 (30 days) — standard support, upgrade scheduling begins
 *   N-2 (60 days) — limited support, mandatory upgrade scheduling
 *   N-3 (90 days) — unsupported, forced upgrade enforcement
 *
 * See requirements/docs/09-promotion-and-release-management.md and
 * requirements/docs/06-operations-and-lifecycle-management.md.
 *
 * @generated from enum deployments.v1.WorkspaceUpgradeStatus
 */
export enum WorkspaceUpgradeStatus {
  /**
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No upgrade pending or in progress.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_NONE = 1;
   */
  NONE = 1,

  /**
   * An upgrade has been scheduled. The customer has been notified
   * (T-30 days) and may reschedule within their assigned release wave
   * window. The upgrade_scheduled_at field on the Workspace message
   * indicates when execution will begin.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_SCHEDULED = 2;
   */
  SCHEDULED = 2,

  /**
   * Upgrade is in progress. Temporal workflow is executing the upgrade
   * steps: pre-flight health checks, backup verification, configuration
   * write to Git, ArgoCD sync via Control Plane, rolling deployment,
   * and post-upgrade validation (smoke tests, performance regression).
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_IN_PROGRESS = 3;
   */
  IN_PROGRESS = 3,

  /**
   * Upgrade completed successfully; post-upgrade validation passed.
   * The current_version field has been updated to the new version.
   * Transitions back to NONE after acknowledgement.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_COMPLETE = 4;
   */
  COMPLETE = 4,

  /**
   * Upgrade failed post-deployment validation. Automatic rollback
   * triggers include: health check failures, critical metric threshold
   * breaches, application crash loops. A support ticket is created
   * and the customer is notified.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_FAILED = 5;
   */
  FAILED = 5,

  /**
   * Rolling back to the previous version after a failed upgrade.
   * Management Plane writes rollback configuration to Git, Control
   * Plane ArgoCD detects the change and pushes previous application
   * versions to the Data Plane.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_ROLLING_BACK = 6;
   */
  ROLLING_BACK = 6,

  /**
   * Rollback completed; workspace is back on the previous version.
   * The current_version field reflects the rolled-back version.
   * Transitions back to NONE after acknowledgement. Uniphore will
   * investigate the failure and schedule a retry after resolution.
   *
   * @generated from enum value: WORKSPACE_UPGRADE_STATUS_ROLLED_BACK = 7;
   */
  ROLLED_BACK = 7,
}

/**
 * Describes the enum deployments.v1.WorkspaceUpgradeStatus.
 */
export const WorkspaceUpgradeStatusSchema: GenEnum<WorkspaceUpgradeStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 5);

/**
 * DeleteMode controls whether cloud infrastructure is torn down before tombstoning
 * the database record.
 *
 * @generated from enum deployments.v1.DeleteMode
 */
export enum DeleteMode {
  /**
   * @generated from enum value: DELETE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * DELETE_MODE_FULL triggers a Temporal workflow to tear down all cloud
   * infrastructure before tombstoning the record. Use this when Uniphore
   * can still assume the customer's IAM role.
   *
   * @generated from enum value: DELETE_MODE_FULL = 1;
   */
  FULL = 1,

  /**
   * DELETE_MODE_FORCE_TOMBSTONE skips infrastructure teardown and immediately
   * tombstones the database record. Use when the IAM role can no longer be
   * assumed (e.g., WORKSPACE_STATUS_BLOCKED) or the customer has already
   * destroyed the infrastructure independently.
   *
   * @generated from enum value: DELETE_MODE_FORCE_TOMBSTONE = 2;
   */
  FORCE_TOMBSTONE = 2,
}

/**
 * Describes the enum deployments.v1.DeleteMode.
 */
export const DeleteModeSchema: GenEnum<DeleteMode> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 6);

/**
 * ControlPlaneType indicates whether a control plane is shared across
 * multiple customers or dedicated to a single customer.
 *
 * @generated from enum deployments.v1.ControlPlaneType
 */
export enum ControlPlaneType {
  /**
   * @generated from enum value: CONTROL_PLANE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default: shared multi-tenant Control Plane Kubernetes cluster with
   * namespace isolation per customer. Provides cost efficiency and
   * operational simplicity. Each customer namespace has its own
   * Crossplane ProviderConfig, resource quotas, circuit breakers,
   * and network policies for blast radius isolation.
   *
   * @generated from enum value: CONTROL_PLANE_TYPE_SHARED = 1;
   */
  SHARED = 1,

  /**
   * Dedicated single-tenant Control Plane Kubernetes cluster for
   * high-security customers. Complete infrastructure isolation
   * (separate cloud account). Higher operational overhead but
   * strongest isolation guarantees. Available upon request for
   * compliance, security, or contractual requirements.
   *
   * @generated from enum value: CONTROL_PLANE_TYPE_DEDICATED = 2;
   */
  DEDICATED = 2,
}

/**
 * Describes the enum deployments.v1.ControlPlaneType.
 */
export const ControlPlaneTypeSchema: GenEnum<ControlPlaneType> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 7);

/**
 * ReleaseDiffStatus reports the outcome of a PreviewReleaseDiff call.
 *
 * @generated from enum deployments.v1.ReleaseDiffStatus
 */
export enum ReleaseDiffStatus {
  /**
   * @generated from enum value: RELEASE_DIFF_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The diff was computed and is populated (diff may be empty if nothing changed).
   *
   * @generated from enum value: RELEASE_DIFF_STATUS_READY = 1;
   */
  READY = 1,

  /**
   * The diff could not be computed; see error_message.
   *
   * @generated from enum value: RELEASE_DIFF_STATUS_FAILED = 2;
   */
  FAILED = 2,

  /**
   * The target release's manifest sync is missing or stale (older than the
   * server's freshness window) - diff is unset. The caller must dispatch
   * releases.v1.ReleasesService/SyncRelease and retry once sync_status
   * becomes SUCCEEDED.
   *
   * @generated from enum value: RELEASE_DIFF_STATUS_SYNC_NEEDED = 3;
   */
  SYNC_NEEDED = 3,
}

/**
 * Describes the enum deployments.v1.ReleaseDiffStatus.
 */
export const ReleaseDiffStatusSchema: GenEnum<ReleaseDiffStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 8);

/**
 * PreflightSeverity classifies how much a failed preflight check matters.
 *
 * @generated from enum deployments.v1.PreflightSeverity
 */
export enum PreflightSeverity {
  /**
   * @generated from enum value: PREFLIGHT_SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Informational only — never blocks and never forces a decision.
   * e.g. a resource that this install creates itself ("will be created").
   *
   * @generated from enum value: PREFLIGHT_SEVERITY_INFO = 1;
   */
  INFO = 1,

  /**
   * A warning the operator should see but which does not block the install.
   * e.g. an existing S3/MSK resource that may need import (idempotency).
   *
   * @generated from enum value: PREFLIGHT_SEVERITY_WARN = 2;
   */
  WARN = 2,

  /**
   * A hard blocker — a missing precondition that would fail the install.
   * e.g. a consumed-but-not-produced AWS secret, or a wrong RDS engine version.
   *
   * @generated from enum value: PREFLIGHT_SEVERITY_BLOCKER = 3;
   */
  BLOCKER = 3,
}

/**
 * Describes the enum deployments.v1.PreflightSeverity.
 */
export const PreflightSeveritySchema: GenEnum<PreflightSeverity> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 9);

/**
 * PreflightStatus is the result of verifying a single requirement.
 *
 * @generated from enum deployments.v1.PreflightStatus
 */
export enum PreflightStatus {
  /**
   * @generated from enum value: PREFLIGHT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The requirement is satisfied (the resource exists / the version matches).
   *
   * @generated from enum value: PREFLIGHT_STATUS_PASS = 1;
   */
  PASS = 1,

  /**
   * The requirement is definitively not satisfied (e.g. secret not found).
   *
   * @generated from enum value: PREFLIGHT_STATUS_FAIL = 2;
   */
  FAIL = 2,

  /**
   * The check was deliberately not run (e.g. k8s checks with no kubeconfig).
   *
   * @generated from enum value: PREFLIGHT_STATUS_SKIPPED = 3;
   */
  SKIPPED = 3,

  /**
   * The check could not be completed — a transport error, missing credentials,
   * or static_only mode. Distinct from FAIL: we don't know either way.
   *
   * @generated from enum value: PREFLIGHT_STATUS_UNKNOWN = 4;
   */
  UNKNOWN = 4,
}

/**
 * Describes the enum deployments.v1.PreflightStatus.
 */
export const PreflightStatusSchema: GenEnum<PreflightStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 10);

/**
 * PreflightOutcome is the overall gate decision derived from all checks.
 *
 * @generated from enum deployments.v1.PreflightOutcome
 */
export enum PreflightOutcome {
  /**
   * @generated from enum value: PREFLIGHT_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No blockers and nothing unknown — the install may proceed normally.
   *
   * @generated from enum value: PREFLIGHT_OUTCOME_CLEAR = 1;
   */
  CLEAR = 1,

  /**
   * No definitive blocker, but at least one check is UNKNOWN. The install
   * must not proceed until the operator explicitly chooses to continue anyway
   * (see CreateWorkspaceRequest.acknowledge_unknowns).
   *
   * @generated from enum value: PREFLIGHT_OUTCOME_NEEDS_DECISION = 2;
   */
  NEEDS_DECISION = 2,

  /**
   * At least one BLOCKER failed — the install is hard-blocked, no override.
   *
   * @generated from enum value: PREFLIGHT_OUTCOME_BLOCKED = 3;
   */
  BLOCKED = 3,
}

/**
 * Describes the enum deployments.v1.PreflightOutcome.
 */
export const PreflightOutcomeSchema: GenEnum<PreflightOutcome> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 11);

/**
 * PreflightRunStatus is the lifecycle state of an async preflight run. The
 * preflight workflow takes longer than the HTTP write timeout, so it runs
 * asynchronously: RunWorkspacePreflight starts it and returns RUNNING, and the
 * UI polls GetWorkspacePreflightStatus until COMPLETED or FAILED.
 *
 * @generated from enum deployments.v1.PreflightRunStatus
 */
export enum PreflightRunStatus {
  /**
   * @generated from enum value: PREFLIGHT_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The preflight workflow is still executing; poll again.
   *
   * @generated from enum value: PREFLIGHT_RUN_STATUS_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * The workflow finished; checks/outcome/blockers/unknowns are populated.
   *
   * @generated from enum value: PREFLIGHT_RUN_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * The workflow failed or timed out; error carries the reason.
   *
   * @generated from enum value: PREFLIGHT_RUN_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum deployments.v1.PreflightRunStatus.
 */
export const PreflightRunStatusSchema: GenEnum<PreflightRunStatus> = /*@__PURE__*/
  enumDesc(file_deployments_v1_deployments, 12);

/**
 * @generated from service deployments.v1.DeploymentService
 */
export const DeploymentService: GenService<{
  /**
   * CreateDeployment creates a new deployment for a tenant. For BYOC
   * models, this generates the provider-specific bootstrap template.
   * The deployment starts in CREATED status.
   *
   * @generated from rpc deployments.v1.DeploymentService.CreateDeployment
   */
  createDeployment: {
    methodKind: "unary";
    input: typeof CreateDeploymentRequestSchema;
    output: typeof CreateDeploymentResponseSchema;
  },
  /**
   * GetDeployment retrieves a deployment by ID, including its current
   * lifecycle status.
   *
   * @generated from rpc deployments.v1.DeploymentService.GetDeployment
   */
  getDeployment: {
    methodKind: "unary";
    input: typeof GetDeploymentRequestSchema;
    output: typeof GetDeploymentResponseSchema;
  },
  /**
   * ListDeployments returns deployments, optionally filtered to a specific tenant.
   *
   * @generated from rpc deployments.v1.DeploymentService.ListDeployments
   */
  listDeployments: {
    methodKind: "unary";
    input: typeof ListDeploymentsRequestSchema;
    output: typeof ListDeploymentsResponseSchema;
  },
  /**
   * ListAccessibleDeployments returns deployments visible under a candidate
   * (not persisted) access-rule scope passed in the request itself — the
   * access wizard's resource-picker / live-preview replacement for the
   * retired PreviewAccessRuleMatch. Admin/Operator Admin only.
   *
   * @generated from rpc deployments.v1.DeploymentService.ListAccessibleDeployments
   */
  listAccessibleDeployments: {
    methodKind: "unary";
    input: typeof ListAccessibleDeploymentsRequestSchema;
    output: typeof ListAccessibleDeploymentsResponseSchema;
  },
  /**
   * GetBootstrapTemplate retrieves the rendered bootstrap template for a
   * deployment from cloud storage. Used by the UI to display the template
   * content without exposing the S3 presigned URL directly.
   *
   * @generated from rpc deployments.v1.DeploymentService.GetBootstrapTemplate
   */
  getBootstrapTemplate: {
    methodKind: "unary";
    input: typeof GetBootstrapTemplateRequestSchema;
    output: typeof GetBootstrapTemplateResponseSchema;
  },
  /**
   * DeleteDeployment initiates deprovisioning of a deployment and all
   * its workspaces. Transitions to DEPROVISIONING status.
   *
   * @generated from rpc deployments.v1.DeploymentService.DeleteDeployment
   */
  deleteDeployment: {
    methodKind: "unary";
    input: typeof DeleteDeploymentRequestSchema;
    output: typeof DeleteDeploymentResponseSchema;
  },
  /**
   * CheckDeploymentDeleteBlockers returns the list of active workspaces that must
   * be deleted before this deployment can be deleted. An empty list means deletion
   * is allowed.
   *
   * @generated from rpc deployments.v1.DeploymentService.CheckDeploymentDeleteBlockers
   */
  checkDeploymentDeleteBlockers: {
    methodKind: "unary";
    input: typeof CheckDeploymentDeleteBlockersRequestSchema;
    output: typeof CheckDeploymentDeleteBlockersResponseSchema;
  },
  /**
   * ListControlPlanes returns control planes, optionally filtered by region.
   *
   * @generated from rpc deployments.v1.DeploymentService.ListControlPlanes
   */
  listControlPlanes: {
    methodKind: "unary";
    input: typeof ListControlPlanesRequestSchema;
    output: typeof ListControlPlanesResponseSchema;
  },
  /**
   * ListDeploymentInfras returns the DuploCloud infrastructures ("plans") that
   * exist in the deployment's portal, queried live. Used to populate the infra
   * selector on workspace creation. A returned name is exactly the value passed
   * as infra on CreateWorkspaceRequest.
   *
   * @generated from rpc deployments.v1.DeploymentService.ListDeploymentInfras
   */
  listDeploymentInfras: {
    methodKind: "unary";
    input: typeof ListDeploymentInfrasRequestSchema;
    output: typeof ListDeploymentInfrasResponseSchema;
  },
  /**
   * StreamDeploymentEvents opens a server-sent stream of deployment change events
   * for a specific deployment. On connect, the current deployment state is sent
   * immediately. Subsequent events fire when the deployment status changes or a
   * new audit event is recorded for the deployment.
   * Stays open until the client disconnects. Authentication: valid JWT required.
   *
   * @generated from rpc deployments.v1.DeploymentService.StreamDeploymentEvents
   */
  streamDeploymentEvents: {
    methodKind: "server_streaming";
    input: typeof StreamDeploymentEventsRequestSchema;
    output: typeof StreamDeploymentEventsResponseSchema;
  },
  /**
   * GetLastDeploymentWorkflowRun returns the most recent deployment-scoped
   * workflow_runs row (workspace_id NULL - e.g. a bulk multi-workspace
   * promote/upgrade) for a deployment's own "what last happened at the
   * deployment level" banner. Per-workspace runs are not returned here - see
   * WorkspaceService.GetLastWorkspaceWorkflowRun for those. Purely a DB read; never
   * returns not-found as an error.
   *
   * @generated from rpc deployments.v1.DeploymentService.GetLastDeploymentWorkflowRun
   */
  getLastDeploymentWorkflowRun: {
    methodKind: "unary";
    input: typeof GetLastDeploymentWorkflowRunRequestSchema;
    output: typeof GetLastDeploymentWorkflowRunResponseSchema;
  },
  /**
   * TriggerTenantMigration fires DuploTenantMigrationWorkflow for the given
   * BAIC deployment. Returns immediately (fire-and-forget). Idempotent: if a
   * migration is already running, returns OK.
   *
   * @generated from rpc deployments.v1.DeploymentService.TriggerTenantMigration
   */
  triggerTenantMigration: {
    methodKind: "unary";
    input: typeof TriggerTenantMigrationRequestSchema;
    output: typeof TriggerTenantMigrationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_deployments_v1_deployments, 0);

/**
 * WorkspaceService manages workspace environments within a deployment.
 *
 * Each workspace is a separate Kubernetes cluster in the customer's
 * infrastructure. Workspaces are provisioned by the Control Plane via
 * DuploCloud and managed through GitOps. Upgrade scheduling and
 * execution are handled by Temporal workflows in the Management Plane,
 * not through this service — this service covers CRUD operations on
 * the workspace resource itself.
 *
 * @generated from service deployments.v1.WorkspaceService
 */
export const WorkspaceService: GenService<{
  /**
   * CreateWorkspace provisions a new workspace (K8s cluster) in a
   * deployment. The Control Plane handles the actual cluster creation
   * via Crossplane. The workspace starts in PROVISIONING status.
   *
   * @generated from rpc deployments.v1.WorkspaceService.CreateWorkspace
   */
  createWorkspace: {
    methodKind: "unary";
    input: typeof CreateWorkspaceRequestSchema;
    output: typeof CreateWorkspaceResponseSchema;
  },
  /**
   * GetWorkspace retrieves a workspace by ID, including both its
   * infrastructure lifecycle status and upgrade status.
   *
   * @generated from rpc deployments.v1.WorkspaceService.GetWorkspace
   */
  getWorkspace: {
    methodKind: "unary";
    input: typeof GetWorkspaceRequestSchema;
    output: typeof GetWorkspaceResponseSchema;
  },
  /**
   * ListWorkspaces returns workspaces, optionally filtered to a specific deployment.
   *
   * @generated from rpc deployments.v1.WorkspaceService.ListWorkspaces
   */
  listWorkspaces: {
    methodKind: "unary";
    input: typeof ListWorkspacesRequestSchema;
    output: typeof ListWorkspacesResponseSchema;
  },
  /**
   * ListAccessibleWorkspaces is ListAccessibleDeployments' workspace
   * counterpart, additionally applying the parent-deployment gate when
   * role_rules/user_rules contain deployment-kind rows (accessrule.decide).
   * Admin/Operator Admin only.
   *
   * @generated from rpc deployments.v1.WorkspaceService.ListAccessibleWorkspaces
   */
  listAccessibleWorkspaces: {
    methodKind: "unary";
    input: typeof ListAccessibleWorkspacesRequestSchema;
    output: typeof ListAccessibleWorkspacesResponseSchema;
  },
  /**
   * DeleteWorkspace initiates deprovisioning of a workspace's
   * Kubernetes cluster and cloud resources. Transitions to
   * DEPROVISIONING status.
   *
   * @generated from rpc deployments.v1.WorkspaceService.DeleteWorkspace
   */
  deleteWorkspace: {
    methodKind: "unary";
    input: typeof DeleteWorkspaceRequestSchema;
    output: typeof DeleteWorkspaceResponseSchema;
  },
  /**
   * UpdateWorkspaceClusterName sets the Kubernetes cluster name used for
   * ArgoCD routing.
   *
   * @generated from rpc deployments.v1.WorkspaceService.UpdateWorkspaceClusterName
   */
  updateWorkspaceClusterName: {
    methodKind: "unary";
    input: typeof UpdateWorkspaceClusterNameRequestSchema;
    output: typeof UpdateWorkspaceClusterNameResponseSchema;
  },
  /**
   * ListAvailableReleases returns non-deprecated releases published after the
   * workspace's current_release_id. If current_release_id is unset (legacy
   * workspace), all non-deprecated releases are returned.
   *
   * @generated from rpc deployments.v1.WorkspaceService.ListAvailableReleases
   */
  listAvailableReleases: {
    methodKind: "unary";
    input: typeof ListAvailableReleasesRequestSchema;
    output: typeof ListAvailableReleasesResponseSchema;
  },
  /**
   * PreviewReleaseDiff re-syncs the workspace's current major release's
   * manifest via x-forge-installer and blocks until the sync completes,
   * returning a diff between what the workspace has deployed and the
   * refreshed manifest. Does not change any workspace or release state -
   * it's a read-only preview. Rejected with FailedPrecondition if the
   * workspace has no current_release_id (legacy workspace).
   *
   * @generated from rpc deployments.v1.WorkspaceService.PreviewReleaseDiff
   */
  previewReleaseDiff: {
    methodKind: "unary";
    input: typeof PreviewReleaseDiffRequestSchema;
    output: typeof PreviewReleaseDiffResponseSchema;
  },
  /**
   * PromoteRelease actually applies a release to the workspace's cluster -
   * dispatches weekly_release_promote.yml and returns immediately without
   * waiting for it to complete (that can take hours, especially behind a
   * manual-approval gate for non-dev tiers). Track progress via the returned
   * workspace's upgrade_status and the workspace's audit history, both of
   * which update live. Rejected with FailedPrecondition if an upgrade is
   * already in progress, or if the workspace has no current_release_id.
   *
   * @generated from rpc deployments.v1.WorkspaceService.PromoteRelease
   */
  promoteRelease: {
    methodKind: "unary";
    input: typeof PromoteReleaseRequestSchema;
    output: typeof PromoteReleaseResponseSchema;
  },
  /**
   * PromoteReleaseMulti fans a release promote out across every named
   * workspace in one batch, all promoted to the same release_id - dispatches
   * release_promote_multi.yml via the releasepromotemulti Temporal workflow
   * and returns immediately without waiting for it to complete. Rejected
   * with FailedPrecondition if the named workspaces aren't all currently on
   * the same current_release_id, don't all belong to the same deployment, or
   * any of them already has an upgrade in progress - no workflow is started
   * in any of those cases. Track progress per workspace via its
   * upgrade_status and audit history.
   *
   * @generated from rpc deployments.v1.WorkspaceService.PromoteReleaseMulti
   */
  promoteReleaseMulti: {
    methodKind: "unary";
    input: typeof PromoteReleaseMultiRequestSchema;
    output: typeof PromoteReleaseMultiResponseSchema;
  },
  /**
   * RunReleasePlan dispatches weekly_release_promote.yml with
   * terraform_operation=plan - a real Terraform dry-run against the target
   * release, applying nothing. Returns immediately without waiting for
   * completion; subscribe to
   * releases.v1.ReleasesService/StreamWorkflowRunEvents with the returned
   * workflow_id/dispatched_at_ms for live output. Purely ephemeral: never
   * mutates upgrade_status and records no audit event. Rejected with
   * FailedPrecondition if an upgrade is already in progress, or if the
   * workspace has no current_release_id.
   *
   * @generated from rpc deployments.v1.WorkspaceService.RunReleasePlan
   */
  runReleasePlan: {
    methodKind: "unary";
    input: typeof RunReleasePlanRequestSchema;
    output: typeof RunReleasePlanResponseSchema;
  },
  /**
   * DeployFromMain dispatches deploy_from_main.yml for a single service off
   * an arbitrary branch - an ad-hoc, targeted deploy against the workspace's
   * live cluster, distinct from PromoteRelease/RunReleasePlan (no release
   * concept, no upgrade_status/current_release_id mutation). Returns
   * immediately without waiting for completion; track progress via the
   * workspace's audit history. Rejected with FailedPrecondition if a deploy
   * is already in progress for this workspace, or if installer_branch is
   * omitted and the workspace has no current_release_id.
   *
   * @generated from rpc deployments.v1.WorkspaceService.DeployFromMain
   */
  deployFromMain: {
    methodKind: "unary";
    input: typeof DeployFromMainRequestSchema;
    output: typeof DeployFromMainResponseSchema;
  },
  /**
   * DeployMai dispatches deploy_mai_components.yml to deploy the MAI component
   * charts to a workspace (isolated terraform/mai root) - a targeted,
   * independently-versioned add-on deploy, distinct from
   * PromoteRelease/RunReleasePlan (no release concept, no
   * upgrade_status/current_release_id mutation). Returns immediately without
   * waiting for completion; track progress via the workspace's audit history.
   * Rejected with FailedPrecondition if a deploy is already in progress for
   * this workspace, or if installer_branch is omitted and the workspace has
   * no current_release_id.
   *
   * @generated from rpc deployments.v1.WorkspaceService.DeployMai
   */
  deployMai: {
    methodKind: "unary";
    input: typeof DeployMaiRequestSchema;
    output: typeof DeployMaiResponseSchema;
  },
  /**
   * DeployBais dispatches sun_deploy_bais.yml (wrapping deploy_bais.yml) to
   * deploy ONLY the BAIS component services to a workspace, scoped via
   * -target - a targeted stack deploy against the workspace's live cluster,
   * distinct from PromoteRelease/RunReleasePlan (no release concept, no
   * upgrade_status/current_release_id mutation). Returns immediately without
   * waiting for completion; track progress via the workspace's audit history.
   * Rejected with FailedPrecondition if a deploy is already in progress for
   * this workspace, or if installer_branch is omitted and the workspace has
   * no current_release_id.
   *
   * @generated from rpc deployments.v1.WorkspaceService.DeployBais
   */
  deployBais: {
    methodKind: "unary";
    input: typeof DeployBaisRequestSchema;
    output: typeof DeployBaisResponseSchema;
  },
  /**
   * GetLastWorkspaceWorkflowRun returns the most recent workflow_runs row for a
   * workspace, optionally scoped via `scope` (see GetLastWorkspaceWorkflowRunRequest) -
   * covers both the page-level "is anything in flight / what last happened"
   * banner (no scope) and a specific resume-after-refresh lookup like the
   * release-plan dry run (scope="release_plan"). Purely a DB read; never
   * returns not-found as an error.
   *
   * @generated from rpc deployments.v1.WorkspaceService.GetLastWorkspaceWorkflowRun
   */
  getLastWorkspaceWorkflowRun: {
    methodKind: "unary";
    input: typeof GetLastWorkspaceWorkflowRunRequestSchema;
    output: typeof GetLastWorkspaceWorkflowRunResponseSchema;
  },
  /**
   * StreamWorkspaceEvents opens a server-sent stream of lifecycle events for a
   * single workspace: status changes, audit events, and workflow_run
   * inserts/status changes. On connect, the current workspace state is sent
   * immediately. Requires Auth0 JWT (authenticated globally by this
   * service's interceptor chain, same as every other WorkspaceService RPC).
   * Stays open until the client disconnects.
   *
   * @generated from rpc deployments.v1.WorkspaceService.StreamWorkspaceEvents
   */
  streamWorkspaceEvents: {
    methodKind: "server_streaming";
    input: typeof StreamWorkspaceEventsRequestSchema;
    output: typeof StreamWorkspaceEventsResponseSchema;
  },
  /**
   * RunWorkspacePreflight starts an async preflight run for a workspace: it
   * launches the PreflightWorkflow Temporal workflow (which scans the installer
   * charts/Terraform and verifies requirements against live backends) and
   * returns immediately with the workflow id and RUNNING status. The UI polls
   * GetWorkspacePreflightStatus for the report. Async because the workflow
   * outlasts the HTTP write timeout.
   *
   * @generated from rpc deployments.v1.WorkspaceService.RunWorkspacePreflight
   */
  runWorkspacePreflight: {
    methodKind: "unary";
    input: typeof RunWorkspacePreflightRequestSchema;
    output: typeof RunWorkspacePreflightResponseSchema;
  },
  /**
   * GetWorkspacePreflightStatus returns the status of the preflight run for a
   * workspace (keyed per deployment+slug) and, once COMPLETED, the compiled and
   * verified report with its overall gate outcome.
   *
   * @generated from rpc deployments.v1.WorkspaceService.GetWorkspacePreflightStatus
   */
  getWorkspacePreflightStatus: {
    methodKind: "unary";
    input: typeof GetWorkspacePreflightStatusRequestSchema;
    output: typeof GetWorkspacePreflightStatusResponseSchema;
  },
  /**
   * RunAdHocPreflight starts an async preflight run against an ad-hoc AWS account
   * (a caller-supplied assumable role + region), with no deployment record. Used
   * for the pre-create readiness gate, where the deployment does not yet exist.
   * Returns the workflow id and RUNNING status; poll GetAdHocPreflightStatus.
   *
   * @generated from rpc deployments.v1.WorkspaceService.RunAdHocPreflight
   */
  runAdHocPreflight: {
    methodKind: "unary";
    input: typeof RunAdHocPreflightRequestSchema;
    output: typeof RunAdHocPreflightResponseSchema;
  },
  /**
   * GetAdHocPreflightStatus returns the status of an ad-hoc preflight run keyed
   * by its workflow id and, once COMPLETED, the verified report.
   *
   * @generated from rpc deployments.v1.WorkspaceService.GetAdHocPreflightStatus
   */
  getAdHocPreflightStatus: {
    methodKind: "unary";
    input: typeof GetAdHocPreflightStatusRequestSchema;
    output: typeof GetAdHocPreflightStatusResponseSchema;
  },
  /**
   * RetryWorkspaceProvisioning resumes provisioning from the failed step for
   * a workspace in PROVISIONING_FAILED status.
   *
   * @generated from rpc deployments.v1.WorkspaceService.RetryWorkspaceProvisioning
   */
  retryWorkspaceProvisioning: {
    methodKind: "unary";
    input: typeof RetryWorkspaceProvisioningRequestSchema;
    output: typeof RetryWorkspaceProvisioningResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_deployments_v1_deployments, 1);

